import * as In from "vue";
import { defineComponent as Te, h as ps, inject as Vr, onMounted as ws, onUnmounted as Hr, Fragment as Je, ref as de, shallowRef as jr, computed as Ct, watch as To, createVNode as dt, Text as Wr, reactive as hs, createElementBlock as G, openBlock as K, createElementVNode as f, createCommentVNode as Fe, toDisplayString as N, unref as _, withDirectives as He, vModelText as it, vModelDynamic as Ao, renderList as Tt, normalizeClass as Kr, createBlock as Yr, Teleport as Gr, withModifiers as gs, resolveComponent as Zn, createTextVNode as Me, withCtx as Kt } from "vue";
/*!
  * shared v11.2.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Ie(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const No = {};
function qr(e) {
  No[e] || (No[e] = !0, Ie(e));
}
const Be = typeof window < "u";
let ge, et;
if (process.env.NODE_ENV !== "production") {
  const e = Be && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (ge = (t) => {
    e.mark(t);
  }, et = (t, n, o) => {
    e.measure(t, n, o), e.clearMarks(n), e.clearMarks(o);
  });
}
const Xr = /\{([0-9a-zA-Z]+)\}/g;
function an(e, ...t) {
  return t.length === 1 && B(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(Xr, (n, o) => t.hasOwnProperty(o) ? t[o] : "");
}
const Ve = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), zr = (e, t, n) => Jr({ l: e, k: t, s: n }), Jr = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), re = (e) => typeof e == "number" && isFinite(e), Zr = (e) => Qn(e) === "[object Date]", Yt = (e) => Qn(e) === "[object RegExp]", ln = (e) => U(e) && Object.keys(e).length === 0, ae = Object.assign, Qr = Object.create, Y = (e = null) => Qr(e);
let xo;
const Ze = () => xo || (xo = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : Y());
function Oo(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function Io(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function ea(e) {
  return e = e.replace(/(\w+)\s*=\s*"([^"]*)"/g, (o, s, r) => `${s}="${Io(r)}"`), e = e.replace(/(\w+)\s*=\s*'([^']*)'/g, (o, s, r) => `${s}='${Io(r)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && Ie("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), [
    // In href, src, action, formaction attributes
    /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
    // In style attributes within url()
    /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
  ].forEach((o) => {
    e = e.replace(o, "$1javascript&#58;");
  }), e;
}
const ta = Object.prototype.hasOwnProperty;
function Ce(e, t) {
  return ta.call(e, t);
}
const ne = Array.isArray, z = (e) => typeof e == "function", x = (e) => typeof e == "string", te = (e) => typeof e == "boolean", B = (e) => e !== null && typeof e == "object", na = (e) => B(e) && z(e.then) && z(e.catch), bs = Object.prototype.toString, Qn = (e) => bs.call(e), U = (e) => Qn(e) === "[object Object]", oa = (e) => e == null ? "" : ne(e) || U(e) && e.toString === bs ? JSON.stringify(e, null, 2) : String(e);
function eo(e, t = "") {
  return e.reduce((n, o, s) => s === 0 ? n + o : n + t + o, "");
}
const Po = 2;
function sa(e, t = 0, n = e.length) {
  const o = e.split(/\r?\n/);
  let s = 0;
  const r = [];
  for (let a = 0; a < o.length; a++)
    if (s += o[a].length + 1, s >= t) {
      for (let i = a - Po; i <= a + Po || n > s; i++) {
        if (i < 0 || i >= o.length)
          continue;
        const u = i + 1;
        r.push(`${u}${" ".repeat(3 - String(u).length)}|  ${o[i]}`);
        const d = o[i].length;
        if (i === a) {
          const v = t - (s - d) + 1, C = Math.max(1, n > s ? d - v : n - t);
          r.push("   |  " + " ".repeat(v) + "^".repeat(C));
        } else if (i > a) {
          if (n > s) {
            const v = Math.max(Math.min(n - s, d), 1);
            r.push("   |  " + "^".repeat(v));
          }
          s += d + 1;
        }
      }
      break;
    }
  return r.join(`
`);
}
function ra() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, o) {
      const s = e.get(n);
      s && s.push(o) || e.set(n, [o]);
    },
    off(n, o) {
      const s = e.get(n);
      s && s.splice(s.indexOf(o) >>> 0, 1);
    },
    emit(n, o) {
      (e.get(n) || []).slice().map((s) => s(o)), (e.get("*") || []).slice().map((s) => s(n, o));
    }
  };
}
const Bt = (e) => !B(e) || ne(e);
function Wt(e, t) {
  if (Bt(e) || Bt(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: o, des: s } = n.pop();
    Object.keys(o).forEach((r) => {
      r !== "__proto__" && (B(o[r]) && !B(s[r]) && (s[r] = Array.isArray(o[r]) ? [] : Y()), Bt(s[r]) || Bt(o[r]) ? s[r] = o[r] : n.push({ src: o[r], des: s[r] }));
    });
  }
}
/*!
  * message-compiler v11.2.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function aa(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Fn(e, t, n) {
  return { start: e, end: t };
}
const M = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, ia = 17, la = {
  // tokenizer error messages
  [M.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [M.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [M.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [M.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [M.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [M.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [M.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [M.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [M.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [M.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [M.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [M.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [M.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [M.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [M.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [M.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function wt(e, t, n = {}) {
  const { domain: o, messages: s, args: r } = n, a = process.env.NODE_ENV !== "production" ? an((s || la)[e] || "", ...r || []) : e, i = new SyntaxError(String(a));
  return i.code = e, t && (i.location = t), i.domain = o, i;
}
function ca(e) {
  throw e;
}
const ua = /<\/?[\w\s="/.':;#-\/]+>/, da = (e) => ua.test(e), Ae = " ", fa = "\r", ce = `
`, ma = "\u2028", pa = "\u2029";
function wa(e) {
  const t = e;
  let n = 0, o = 1, s = 1, r = 0;
  const a = (E) => t[E] === fa && t[E + 1] === ce, i = (E) => t[E] === ce, u = (E) => t[E] === pa, d = (E) => t[E] === ma, v = (E) => a(E) || i(E) || u(E) || d(E), C = () => n, h = () => o, P = () => s, $ = () => r, O = (E) => a(E) || u(E) || d(E) ? ce : t[E], S = () => O(n), p = () => O(n + r);
  function g() {
    return r = 0, v(n) && (o++, s = 0), a(n) && n++, n++, s++, t[n];
  }
  function L() {
    return a(n + r) && r++, r++, t[n + r];
  }
  function b() {
    n = 0, o = 1, s = 1, r = 0;
  }
  function T(E = 0) {
    r = E;
  }
  function A() {
    const E = n + r;
    for (; E !== n; )
      g();
    r = 0;
  }
  return {
    index: C,
    line: h,
    column: P,
    peekOffset: $,
    charAt: O,
    currentChar: S,
    currentPeek: p,
    next: g,
    peek: L,
    reset: b,
    resetPeek: T,
    skipToPeek: A
  };
}
const $e = void 0, ha = ".", So = "'", ga = "tokenizer";
function ba(e, t = {}) {
  const n = t.location !== !1, o = wa(e), s = () => o.index(), r = () => aa(o.line(), o.column(), o.index()), a = r(), i = s(), u = {
    currentType: 13,
    offset: i,
    startLoc: a,
    endLoc: a,
    lastType: 13,
    lastOffset: i,
    lastStartLoc: a,
    lastEndLoc: a,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, d = () => u, { onError: v } = t;
  function C(l, c, y, ...I) {
    const X = d();
    if (c.column += y, c.offset += y, v) {
      const Z = n ? Fn(X.startLoc, c) : null, F = wt(l, Z, {
        domain: ga,
        args: I
      });
      v(F);
    }
  }
  function h(l, c, y) {
    l.endLoc = r(), l.currentType = c;
    const I = { type: c };
    return n && (I.loc = Fn(l.startLoc, l.endLoc)), y != null && (I.value = y), I;
  }
  const P = (l) => h(
    l,
    13
    /* TokenTypes.EOF */
  );
  function $(l, c) {
    return l.currentChar() === c ? (l.next(), c) : (C(M.EXPECTED_TOKEN, r(), 0, c), "");
  }
  function O(l) {
    let c = "";
    for (; l.currentPeek() === Ae || l.currentPeek() === ce; )
      c += l.currentPeek(), l.peek();
    return c;
  }
  function S(l) {
    const c = O(l);
    return l.skipToPeek(), c;
  }
  function p(l) {
    if (l === $e)
      return !1;
    const c = l.charCodeAt(0);
    return c >= 97 && c <= 122 || // a-z
    c >= 65 && c <= 90 || // A-Z
    c === 95;
  }
  function g(l) {
    if (l === $e)
      return !1;
    const c = l.charCodeAt(0);
    return c >= 48 && c <= 57;
  }
  function L(l, c) {
    const { currentType: y } = c;
    if (y !== 2)
      return !1;
    O(l);
    const I = p(l.currentPeek());
    return l.resetPeek(), I;
  }
  function b(l, c) {
    const { currentType: y } = c;
    if (y !== 2)
      return !1;
    O(l);
    const I = l.currentPeek() === "-" ? l.peek() : l.currentPeek(), X = g(I);
    return l.resetPeek(), X;
  }
  function T(l, c) {
    const { currentType: y } = c;
    if (y !== 2)
      return !1;
    O(l);
    const I = l.currentPeek() === So;
    return l.resetPeek(), I;
  }
  function A(l, c) {
    const { currentType: y } = c;
    if (y !== 7)
      return !1;
    O(l);
    const I = l.currentPeek() === ".";
    return l.resetPeek(), I;
  }
  function E(l, c) {
    const { currentType: y } = c;
    if (y !== 8)
      return !1;
    O(l);
    const I = p(l.currentPeek());
    return l.resetPeek(), I;
  }
  function R(l, c) {
    const { currentType: y } = c;
    if (!(y === 7 || y === 11))
      return !1;
    O(l);
    const I = l.currentPeek() === ":";
    return l.resetPeek(), I;
  }
  function W(l, c) {
    const { currentType: y } = c;
    if (y !== 9)
      return !1;
    const I = () => {
      const Z = l.currentPeek();
      return Z === "{" ? p(l.peek()) : Z === "@" || Z === "|" || Z === ":" || Z === "." || Z === Ae || !Z ? !1 : Z === ce ? (l.peek(), I()) : ke(l, !1);
    }, X = I();
    return l.resetPeek(), X;
  }
  function se(l) {
    O(l);
    const c = l.currentPeek() === "|";
    return l.resetPeek(), c;
  }
  function ke(l, c = !0) {
    const y = (X = !1, Z = "") => {
      const F = l.currentPeek();
      return F === "{" || F === "@" || !F ? X : F === "|" ? !(Z === Ae || Z === ce) : F === Ae ? (l.peek(), y(!0, Ae)) : F === ce ? (l.peek(), y(!0, ce)) : !0;
    }, I = y();
    return c && l.resetPeek(), I;
  }
  function J(l, c) {
    const y = l.currentChar();
    return y === $e ? $e : c(y) ? (l.next(), y) : null;
  }
  function rt(l) {
    const c = l.charCodeAt(0);
    return c >= 97 && c <= 122 || // a-z
    c >= 65 && c <= 90 || // A-Z
    c >= 48 && c <= 57 || // 0-9
    c === 95 || // _
    c === 36;
  }
  function hn(l) {
    return J(l, rt);
  }
  function gn(l) {
    const c = l.charCodeAt(0);
    return c >= 97 && c <= 122 || // a-z
    c >= 65 && c <= 90 || // A-Z
    c >= 48 && c <= 57 || // 0-9
    c === 95 || // _
    c === 36 || // $
    c === 45;
  }
  function bn(l) {
    return J(l, gn);
  }
  function _n(l) {
    const c = l.charCodeAt(0);
    return c >= 48 && c <= 57;
  }
  function yn(l) {
    return J(l, _n);
  }
  function vn(l) {
    const c = l.charCodeAt(0);
    return c >= 48 && c <= 57 || // 0-9
    c >= 65 && c <= 70 || // A-F
    c >= 97 && c <= 102;
  }
  function De(l) {
    return J(l, vn);
  }
  function yt(l) {
    let c = "", y = "";
    for (; c = yn(l); )
      y += c;
    return y;
  }
  function En(l) {
    let c = "";
    for (; ; ) {
      const y = l.currentChar();
      if (y === "{" || y === "}" || y === "@" || y === "|" || !y)
        break;
      if (y === Ae || y === ce)
        if (ke(l))
          c += y, l.next();
        else {
          if (se(l))
            break;
          c += y, l.next();
        }
      else
        c += y, l.next();
    }
    return c;
  }
  function kn(l) {
    S(l);
    let c = "", y = "";
    for (; c = bn(l); )
      y += c;
    const I = l.currentChar();
    if (I && I !== "}" && I !== $e && I !== Ae && I !== ce && I !== "　") {
      const X = Ft(l);
      return C(M.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, y + X), y + X;
    }
    return l.currentChar() === $e && C(M.UNTERMINATED_CLOSING_BRACE, r(), 0), y;
  }
  function Cn(l) {
    S(l);
    let c = "";
    return l.currentChar() === "-" ? (l.next(), c += `-${yt(l)}`) : c += yt(l), l.currentChar() === $e && C(M.UNTERMINATED_CLOSING_BRACE, r(), 0), c;
  }
  function Ln(l) {
    return l !== So && l !== ce;
  }
  function Co(l) {
    S(l), $(l, "'");
    let c = "", y = "";
    for (; c = J(l, Ln); )
      c === "\\" ? y += Tn(l) : y += c;
    const I = l.currentChar();
    return I === ce || I === $e ? (C(M.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, r(), 0), I === ce && (l.next(), $(l, "'")), y) : ($(l, "'"), y);
  }
  function Tn(l) {
    const c = l.currentChar();
    switch (c) {
      case "\\":
      case "'":
        return l.next(), `\\${c}`;
      case "u":
        return Rt(l, c, 4);
      case "U":
        return Rt(l, c, 6);
      default:
        return C(M.UNKNOWN_ESCAPE_SEQUENCE, r(), 0, c), "";
    }
  }
  function Rt(l, c, y) {
    $(l, c);
    let I = "";
    for (let X = 0; X < y; X++) {
      const Z = De(l);
      if (!Z) {
        C(M.INVALID_UNICODE_ESCAPE_SEQUENCE, r(), 0, `\\${c}${I}${l.currentChar()}`);
        break;
      }
      I += Z;
    }
    return `\\${c}${I}`;
  }
  function An(l) {
    return l !== "{" && l !== "}" && l !== Ae && l !== ce;
  }
  function Ft(l) {
    S(l);
    let c = "", y = "";
    for (; c = J(l, An); )
      y += c;
    return y;
  }
  function Nn(l) {
    let c = "", y = "";
    for (; c = hn(l); )
      y += c;
    return y;
  }
  function xn(l) {
    const c = (y) => {
      const I = l.currentChar();
      return I === "{" || I === "@" || I === "|" || I === "(" || I === ")" || !I || I === Ae ? y : (y += I, l.next(), c(y));
    };
    return c("");
  }
  function vt(l) {
    S(l);
    const c = $(
      l,
      "|"
      /* TokenChars.Pipe */
    );
    return S(l), c;
  }
  function Et(l, c) {
    let y = null;
    switch (l.currentChar()) {
      case "{":
        return c.braceNest >= 1 && C(M.NOT_ALLOW_NEST_PLACEHOLDER, r(), 0), l.next(), y = h(
          c,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), S(l), c.braceNest++, y;
      case "}":
        return c.braceNest > 0 && c.currentType === 2 && C(M.EMPTY_PLACEHOLDER, r(), 0), l.next(), y = h(
          c,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), c.braceNest--, c.braceNest > 0 && S(l), c.inLinked && c.braceNest === 0 && (c.inLinked = !1), y;
      case "@":
        return c.braceNest > 0 && C(M.UNTERMINATED_CLOSING_BRACE, r(), 0), y = Ge(l, c) || P(c), c.braceNest = 0, y;
      default: {
        let X = !0, Z = !0, F = !0;
        if (se(l))
          return c.braceNest > 0 && C(M.UNTERMINATED_CLOSING_BRACE, r(), 0), y = h(c, 1, vt(l)), c.braceNest = 0, c.inLinked = !1, y;
        if (c.braceNest > 0 && (c.currentType === 4 || c.currentType === 5 || c.currentType === 6))
          return C(M.UNTERMINATED_CLOSING_BRACE, r(), 0), c.braceNest = 0, kt(l, c);
        if (X = L(l, c))
          return y = h(c, 4, kn(l)), S(l), y;
        if (Z = b(l, c))
          return y = h(c, 5, Cn(l)), S(l), y;
        if (F = T(l, c))
          return y = h(c, 6, Co(l)), S(l), y;
        if (!X && !Z && !F)
          return y = h(c, 12, Ft(l)), C(M.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, y.value), S(l), y;
        break;
      }
    }
    return y;
  }
  function Ge(l, c) {
    const { currentType: y } = c;
    let I = null;
    const X = l.currentChar();
    switch ((y === 7 || y === 8 || y === 11 || y === 9) && (X === ce || X === Ae) && C(M.INVALID_LINKED_FORMAT, r(), 0), X) {
      case "@":
        return l.next(), I = h(
          c,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), c.inLinked = !0, I;
      case ".":
        return S(l), l.next(), h(
          c,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return S(l), l.next(), h(
          c,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return se(l) ? (I = h(c, 1, vt(l)), c.braceNest = 0, c.inLinked = !1, I) : A(l, c) || R(l, c) ? (S(l), Ge(l, c)) : E(l, c) ? (S(l), h(c, 11, Nn(l))) : W(l, c) ? (S(l), X === "{" ? Et(l, c) || I : h(c, 10, xn(l))) : (y === 7 && C(M.INVALID_LINKED_FORMAT, r(), 0), c.braceNest = 0, c.inLinked = !1, kt(l, c));
    }
  }
  function kt(l, c) {
    let y = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (c.braceNest > 0)
      return Et(l, c) || P(c);
    if (c.inLinked)
      return Ge(l, c) || P(c);
    switch (l.currentChar()) {
      case "{":
        return Et(l, c) || P(c);
      case "}":
        return C(M.UNBALANCED_CLOSING_BRACE, r(), 0), l.next(), h(
          c,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return Ge(l, c) || P(c);
      default: {
        if (se(l))
          return y = h(c, 1, vt(l)), c.braceNest = 0, c.inLinked = !1, y;
        if (ke(l))
          return h(c, 0, En(l));
        break;
      }
    }
    return y;
  }
  function On() {
    const { currentType: l, offset: c, startLoc: y, endLoc: I } = u;
    return u.lastType = l, u.lastOffset = c, u.lastStartLoc = y, u.lastEndLoc = I, u.offset = s(), u.startLoc = r(), o.currentChar() === $e ? h(
      u,
      13
      /* TokenTypes.EOF */
    ) : kt(o, u);
  }
  return {
    nextToken: On,
    currentOffset: s,
    currentPosition: r,
    context: d
  };
}
const _a = "parser", ya = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function va(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const o = parseInt(t || n, 16);
      return o <= 55295 || o >= 57344 ? String.fromCodePoint(o) : "�";
    }
  }
}
function Ea(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function o(p, g, L, b, ...T) {
    const A = p.currentPosition();
    if (A.offset += b, A.column += b, n) {
      const E = t ? Fn(L, A) : null, R = wt(g, E, {
        domain: _a,
        args: T
      });
      n(R);
    }
  }
  function s(p, g, L) {
    const b = { type: p };
    return t && (b.start = g, b.end = g, b.loc = { start: L, end: L }), b;
  }
  function r(p, g, L, b) {
    t && (p.end = g, p.loc && (p.loc.end = L));
  }
  function a(p, g) {
    const L = p.context(), b = s(3, L.offset, L.startLoc);
    return b.value = g, r(b, p.currentOffset(), p.currentPosition()), b;
  }
  function i(p, g) {
    const L = p.context(), { lastOffset: b, lastStartLoc: T } = L, A = s(5, b, T);
    return A.index = parseInt(g, 10), p.nextToken(), r(A, p.currentOffset(), p.currentPosition()), A;
  }
  function u(p, g) {
    const L = p.context(), { lastOffset: b, lastStartLoc: T } = L, A = s(4, b, T);
    return A.key = g, p.nextToken(), r(A, p.currentOffset(), p.currentPosition()), A;
  }
  function d(p, g) {
    const L = p.context(), { lastOffset: b, lastStartLoc: T } = L, A = s(9, b, T);
    return A.value = g.replace(ya, va), p.nextToken(), r(A, p.currentOffset(), p.currentPosition()), A;
  }
  function v(p) {
    const g = p.nextToken(), L = p.context(), { lastOffset: b, lastStartLoc: T } = L, A = s(8, b, T);
    return g.type !== 11 ? (o(p, M.UNEXPECTED_EMPTY_LINKED_MODIFIER, L.lastStartLoc, 0), A.value = "", r(A, b, T), {
      nextConsumeToken: g,
      node: A
    }) : (g.value == null && o(p, M.UNEXPECTED_LEXICAL_ANALYSIS, L.lastStartLoc, 0, Ne(g)), A.value = g.value || "", r(A, p.currentOffset(), p.currentPosition()), {
      node: A
    });
  }
  function C(p, g) {
    const L = p.context(), b = s(7, L.offset, L.startLoc);
    return b.value = g, r(b, p.currentOffset(), p.currentPosition()), b;
  }
  function h(p) {
    const g = p.context(), L = s(6, g.offset, g.startLoc);
    let b = p.nextToken();
    if (b.type === 8) {
      const T = v(p);
      L.modifier = T.node, b = T.nextConsumeToken || p.nextToken();
    }
    switch (b.type !== 9 && o(p, M.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Ne(b)), b = p.nextToken(), b.type === 2 && (b = p.nextToken()), b.type) {
      case 10:
        b.value == null && o(p, M.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Ne(b)), L.key = C(p, b.value || "");
        break;
      case 4:
        b.value == null && o(p, M.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Ne(b)), L.key = u(p, b.value || "");
        break;
      case 5:
        b.value == null && o(p, M.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Ne(b)), L.key = i(p, b.value || "");
        break;
      case 6:
        b.value == null && o(p, M.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Ne(b)), L.key = d(p, b.value || "");
        break;
      default: {
        o(p, M.UNEXPECTED_EMPTY_LINKED_KEY, g.lastStartLoc, 0);
        const T = p.context(), A = s(7, T.offset, T.startLoc);
        return A.value = "", r(A, T.offset, T.startLoc), L.key = A, r(L, T.offset, T.startLoc), {
          nextConsumeToken: b,
          node: L
        };
      }
    }
    return r(L, p.currentOffset(), p.currentPosition()), {
      node: L
    };
  }
  function P(p) {
    const g = p.context(), L = g.currentType === 1 ? p.currentOffset() : g.offset, b = g.currentType === 1 ? g.endLoc : g.startLoc, T = s(2, L, b);
    T.items = [];
    let A = null;
    do {
      const W = A || p.nextToken();
      switch (A = null, W.type) {
        case 0:
          W.value == null && o(p, M.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Ne(W)), T.items.push(a(p, W.value || ""));
          break;
        case 5:
          W.value == null && o(p, M.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Ne(W)), T.items.push(i(p, W.value || ""));
          break;
        case 4:
          W.value == null && o(p, M.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Ne(W)), T.items.push(u(p, W.value || ""));
          break;
        case 6:
          W.value == null && o(p, M.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, Ne(W)), T.items.push(d(p, W.value || ""));
          break;
        case 7: {
          const se = h(p);
          T.items.push(se.node), A = se.nextConsumeToken || null;
          break;
        }
      }
    } while (g.currentType !== 13 && g.currentType !== 1);
    const E = g.currentType === 1 ? g.lastOffset : p.currentOffset(), R = g.currentType === 1 ? g.lastEndLoc : p.currentPosition();
    return r(T, E, R), T;
  }
  function $(p, g, L, b) {
    const T = p.context();
    let A = b.items.length === 0;
    const E = s(1, g, L);
    E.cases = [], E.cases.push(b);
    do {
      const R = P(p);
      A || (A = R.items.length === 0), E.cases.push(R);
    } while (T.currentType !== 13);
    return A && o(p, M.MUST_HAVE_MESSAGES_IN_PLURAL, L, 0), r(E, p.currentOffset(), p.currentPosition()), E;
  }
  function O(p) {
    const g = p.context(), { offset: L, startLoc: b } = g, T = P(p);
    return g.currentType === 13 ? T : $(p, L, b, T);
  }
  function S(p) {
    const g = ba(p, ae({}, e)), L = g.context(), b = s(0, L.offset, L.startLoc);
    return t && b.loc && (b.loc.source = p), b.body = O(g), e.onCacheKey && (b.cacheKey = e.onCacheKey(p)), L.currentType !== 13 && o(g, M.UNEXPECTED_LEXICAL_ANALYSIS, L.lastStartLoc, 0, p[L.offset] || ""), r(b, g.currentOffset(), g.currentPosition()), b;
  }
  return { parse: S };
}
function Ne(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function ka(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (r) => (n.helpers.add(r), r) };
}
function Do(e, t) {
  for (let n = 0; n < e.length; n++)
    to(e[n], t);
}
function to(e, t) {
  switch (e.type) {
    case 1:
      Do(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Do(e.items, t);
      break;
    case 6: {
      to(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function Ca(e, t = {}) {
  const n = ka(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && to(e.body, n);
  const o = n.context();
  e.helpers = Array.from(o.helpers);
}
function La(e) {
  const t = e.body;
  return t.type === 2 ? $o(t) : t.cases.forEach((n) => $o(n)), e;
}
function $o(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const o = e.items[n];
      if (!(o.type === 3 || o.type === 9) || o.value == null)
        break;
      t.push(o.value);
    }
    if (t.length === e.items.length) {
      e.static = eo(t);
      for (let n = 0; n < e.items.length; n++) {
        const o = e.items[n];
        (o.type === 3 || o.type === 9) && delete o.value;
      }
    }
  }
}
const Ta = "minifier";
function lt(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      lt(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let o = 0; o < n.length; o++)
        lt(n[o]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let o = 0; o < n.length; o++)
        lt(n[o]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      lt(t.key), t.k = t.key, delete t.key, t.modifier && (lt(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw wt(M.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: Ta,
          args: [e.type]
        });
  }
  delete e.type;
}
const Aa = "parser";
function Na(e, t) {
  const { filename: n, breakLineCode: o, needIndent: s } = t, r = t.location !== !1, a = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: o,
    needIndent: s,
    indentLevel: 0
  };
  r && e.loc && (a.source = e.loc.source);
  const i = () => a;
  function u(O, S) {
    a.code += O;
  }
  function d(O, S = !0) {
    const p = S ? o : "";
    u(s ? p + "  ".repeat(O) : p);
  }
  function v(O = !0) {
    const S = ++a.indentLevel;
    O && d(S);
  }
  function C(O = !0) {
    const S = --a.indentLevel;
    O && d(S);
  }
  function h() {
    d(a.indentLevel);
  }
  return {
    context: i,
    push: u,
    indent: v,
    deindent: C,
    newline: h,
    helper: (O) => `_${O}`,
    needIndent: () => a.needIndent
  };
}
function xa(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), ft(e, t.key), t.modifier ? (e.push(", "), ft(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Oa(e, t) {
  const { helper: n, needIndent: o } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(o());
  const s = t.items.length;
  for (let r = 0; r < s && (ft(e, t.items[r]), r !== s - 1); r++)
    e.push(", ");
  e.deindent(o()), e.push("])");
}
function Ia(e, t) {
  const { helper: n, needIndent: o } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(o());
    const s = t.cases.length;
    for (let r = 0; r < s && (ft(e, t.cases[r]), r !== s - 1); r++)
      e.push(", ");
    e.deindent(o()), e.push("])");
  }
}
function Pa(e, t) {
  t.body ? ft(e, t.body) : e.push("null");
}
function ft(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      Pa(e, t);
      break;
    case 1:
      Ia(e, t);
      break;
    case 2:
      Oa(e, t);
      break;
    case 6:
      xa(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw wt(M.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: Aa,
          args: [t.type]
        });
  }
}
const Sa = (e, t = {}) => {
  const n = x(t.mode) ? t.mode : "normal", o = x(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const s = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, r = t.needIndent ? t.needIndent : n !== "arrow", a = e.helpers || [], i = Na(e, {
    filename: o,
    breakLineCode: s,
    needIndent: r
  });
  i.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), i.indent(r), a.length > 0 && (i.push(`const { ${eo(a.map((v) => `${v}: _${v}`), ", ")} } = ctx`), i.newline()), i.push("return "), ft(i, e), i.deindent(r), i.push("}"), delete e.helpers;
  const { code: u, map: d } = i.context();
  return {
    ast: e,
    code: u,
    map: d ? d.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Da(e, t = {}) {
  const n = ae({}, t), o = !!n.jit, s = !!n.minify, r = n.optimize == null ? !0 : n.optimize, i = Ea(n).parse(e);
  return o ? (r && La(i), s && lt(i), { ast: i, code: "" }) : (Ca(i, n), Sa(i, n));
}
/*!
  * core-base v11.2.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function $a() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Ze().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Ze().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function Le(e) {
  return B(e) && no(e) === 0 && (Ce(e, "b") || Ce(e, "body"));
}
const _s = ["b", "body"];
function Ma(e) {
  return Ke(e, _s);
}
const ys = ["c", "cases"];
function Ra(e) {
  return Ke(e, ys, []);
}
const vs = ["s", "static"];
function Fa(e) {
  return Ke(e, vs);
}
const Es = ["i", "items"];
function Ua(e) {
  return Ke(e, Es, []);
}
const ks = ["t", "type"];
function no(e) {
  return Ke(e, ks);
}
const Cs = ["v", "value"];
function Vt(e, t) {
  const n = Ke(e, Cs);
  if (n != null)
    return n;
  throw At(t);
}
const Ls = ["m", "modifier"];
function Ba(e) {
  return Ke(e, Ls);
}
const Ts = ["k", "key"];
function Va(e) {
  const t = Ke(e, Ts);
  if (t)
    return t;
  throw At(
    6
    /* NodeTypes.Linked */
  );
}
function Ke(e, t, n) {
  for (let o = 0; o < t.length; o++) {
    const s = t[o];
    if (Ce(e, s) && e[s] != null)
      return e[s];
  }
  return n;
}
const As = [
  ..._s,
  ...ys,
  ...vs,
  ...Es,
  ...Ts,
  ...Ls,
  ...Cs,
  ...ks
];
function At(e) {
  return new Error(`unhandled node type: ${e}`);
}
function Pn(e) {
  return (n) => Ha(n, e);
}
function Ha(e, t) {
  const n = Ma(t);
  if (n == null)
    throw At(
      0
      /* NodeTypes.Resource */
    );
  if (no(n) === 1) {
    const r = Ra(n);
    return e.plural(r.reduce((a, i) => [
      ...a,
      Mo(e, i)
    ], []));
  } else
    return Mo(e, n);
}
function Mo(e, t) {
  const n = Fa(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const o = Ua(t).reduce((s, r) => [...s, Un(e, r)], []);
    return e.normalize(o);
  }
}
function Un(e, t) {
  const n = no(t);
  switch (n) {
    case 3:
      return Vt(t, n);
    case 9:
      return Vt(t, n);
    case 4: {
      const o = t;
      if (Ce(o, "k") && o.k)
        return e.interpolate(e.named(o.k));
      if (Ce(o, "key") && o.key)
        return e.interpolate(e.named(o.key));
      throw At(n);
    }
    case 5: {
      const o = t;
      if (Ce(o, "i") && re(o.i))
        return e.interpolate(e.list(o.i));
      if (Ce(o, "index") && re(o.index))
        return e.interpolate(e.list(o.index));
      throw At(n);
    }
    case 6: {
      const o = t, s = Ba(o), r = Va(o);
      return e.linked(Un(e, r), s ? Un(e, s) : void 0, e.type);
    }
    case 7:
      return Vt(t, n);
    case 8:
      return Vt(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const ja = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function Wa(e, t) {
  t && da(e) && Ie(an(ja, { source: e }));
}
const Ka = (e) => e;
let Ht = Y();
function Ya(e, t = {}) {
  let n = !1;
  const o = t.onError || ca;
  return t.onError = (s) => {
    n = !0, o(s);
  }, { ...Da(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function Ga(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && x(e)) {
    const n = te(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && Wa(e, n);
    const s = (t.onCacheKey || Ka)(e), r = Ht[s];
    if (r)
      return r;
    const { ast: a, detectError: i } = Ya(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), u = Pn(a);
    return i ? u : Ht[s] = u;
  } else {
    if (process.env.NODE_ENV !== "production" && !Le(e))
      return Ie(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const o = Ht[n];
      return o || (Ht[n] = Pn(e));
    } else
      return Pn(e);
  }
}
let Nt = null;
function qa(e) {
  Nt = e;
}
function Xa(e, t, n) {
  Nt && Nt.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const za = /* @__PURE__ */ Ja("function:translate");
function Ja(e) {
  return (t) => Nt && Nt.emit(e, t);
}
const ue = {
  INVALID_ARGUMENT: ia,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, Za = 24;
function Re(e) {
  return wt(e, null, process.env.NODE_ENV !== "production" ? { messages: Qa } : void 0);
}
const Qa = {
  [ue.INVALID_ARGUMENT]: "Invalid arguments",
  [ue.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [ue.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [ue.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [ue.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [ue.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [ue.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function oo(e, t) {
  return t.locale != null ? Ro(t.locale) : Ro(e.locale);
}
let Sn;
function Ro(e) {
  if (x(e))
    return e;
  if (z(e)) {
    if (e.resolvedOnce && Sn != null)
      return Sn;
    if (e.constructor.name === "Function") {
      const t = e();
      if (na(t))
        throw Re(ue.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Sn = t;
    } else
      throw Re(ue.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw Re(ue.NOT_SUPPORT_LOCALE_TYPE);
}
function ei(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...ne(t) ? t : B(t) ? Object.keys(t) : x(t) ? [t] : [n]
  ])];
}
function Ns(e, t, n) {
  const o = x(n) ? n : Gt, s = e;
  s.__localeChainCache || (s.__localeChainCache = /* @__PURE__ */ new Map());
  let r = s.__localeChainCache.get(o);
  if (!r) {
    r = [];
    let a = [n];
    for (; ne(a); )
      a = Fo(r, a, t);
    const i = ne(t) || !U(t) ? t : t.default ? t.default : null;
    a = x(i) ? [i] : i, ne(a) && Fo(r, a, !1), s.__localeChainCache.set(o, r);
  }
  return r;
}
function Fo(e, t, n) {
  let o = !0;
  for (let s = 0; s < t.length && te(o); s++) {
    const r = t[s];
    x(r) && (o = ti(e, t[s], n));
  }
  return o;
}
function ti(e, t, n) {
  let o;
  const s = t.split("-");
  do {
    const r = s.join("-");
    o = ni(e, r, n), s.splice(-1, 1);
  } while (s.length && o === !0);
  return o;
}
function ni(e, t, n) {
  let o = !1;
  if (!e.includes(t) && (o = !0, t)) {
    o = t[t.length - 1] !== "!";
    const s = t.replace(/!/g, "");
    e.push(s), (ne(n) || U(n)) && n[s] && (o = n[s]);
  }
  return o;
}
const Ye = [];
Ye[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Ye[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Ye[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
Ye[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
Ye[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
Ye[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
Ye[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const oi = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function si(e) {
  return oi.test(e);
}
function ri(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function ai(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function ii(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : si(t) ? ri(t) : "*" + t;
}
function li(e) {
  const t = [];
  let n = -1, o = 0, s = 0, r, a, i, u, d, v, C;
  const h = [];
  h[
    0
    /* Actions.APPEND */
  ] = () => {
    a === void 0 ? a = i : a += i;
  }, h[
    1
    /* Actions.PUSH */
  ] = () => {
    a !== void 0 && (t.push(a), a = void 0);
  }, h[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    h[
      0
      /* Actions.APPEND */
    ](), s++;
  }, h[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (s > 0)
      s--, o = 4, h[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (s = 0, a === void 0 || (a = ii(a), a === !1))
        return !1;
      h[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function P() {
    const $ = e[n + 1];
    if (o === 5 && $ === "'" || o === 6 && $ === '"')
      return n++, i = "\\" + $, h[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; o !== null; )
    if (n++, r = e[n], !(r === "\\" && P())) {
      if (u = ai(r), C = Ye[o], d = C[u] || C.l || 8, d === 8 || (o = d[0], d[1] !== void 0 && (v = h[d[1]], v && (i = r, v() === !1))))
        return;
      if (o === 7)
        return t;
    }
}
const Uo = /* @__PURE__ */ new Map();
function ci(e, t) {
  return B(e) ? e[t] : null;
}
function ui(e, t) {
  if (!B(e))
    return null;
  let n = Uo.get(t);
  if (n || (n = li(t), n && Uo.set(t, n)), !n)
    return null;
  const o = n.length;
  let s = e, r = 0;
  for (; r < o; ) {
    const a = n[r];
    if (As.includes(a) && Le(s))
      return null;
    const i = s[a];
    if (i === void 0 || z(s))
      return null;
    s = i, r++;
  }
  return s;
}
const we = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, di = 8, fi = {
  [we.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [we.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [we.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [we.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [we.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [we.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [we.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function tt(e, ...t) {
  return an(fi[e], ...t);
}
const mi = "11.2.8", cn = -1, Gt = "en-US", qt = "", Bo = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function pi() {
  return {
    upper: (e, t) => t === "text" && x(e) ? e.toUpperCase() : t === "vnode" && B(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && x(e) ? e.toLowerCase() : t === "vnode" && B(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && x(e) ? Bo(e) : t === "vnode" && B(e) && "__v_isVNode" in e ? Bo(e.children) : e
  };
}
let xs;
function wi(e) {
  xs = e;
}
let Os;
function hi(e) {
  Os = e;
}
let Is;
function gi(e) {
  Is = e;
}
let Ps = null;
const bi = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  Ps = e;
}, _i = /* @__NO_SIDE_EFFECTS__ */ () => Ps;
let Ss = null;
const Vo = (e) => {
  Ss = e;
}, yi = () => Ss;
let Ho = 0;
function vi(e = {}) {
  const t = z(e.onWarn) ? e.onWarn : Ie, n = x(e.version) ? e.version : mi, o = x(e.locale) || z(e.locale) ? e.locale : Gt, s = z(o) ? Gt : o, r = ne(e.fallbackLocale) || U(e.fallbackLocale) || x(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : s, a = U(e.messages) ? e.messages : Dn(s), i = U(e.datetimeFormats) ? e.datetimeFormats : Dn(s), u = U(e.numberFormats) ? e.numberFormats : Dn(s), d = ae(Y(), e.modifiers, pi()), v = e.pluralRules || Y(), C = z(e.missing) ? e.missing : null, h = te(e.missingWarn) || Yt(e.missingWarn) ? e.missingWarn : !0, P = te(e.fallbackWarn) || Yt(e.fallbackWarn) ? e.fallbackWarn : !0, $ = !!e.fallbackFormat, O = !!e.unresolving, S = z(e.postTranslation) ? e.postTranslation : null, p = U(e.processor) ? e.processor : null, g = te(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, L = !!e.escapeParameter, b = z(e.messageCompiler) ? e.messageCompiler : xs;
  process.env.NODE_ENV !== "production" && z(e.messageCompiler) && qr(tt(we.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const T = z(e.messageResolver) ? e.messageResolver : Os || ci, A = z(e.localeFallbacker) ? e.localeFallbacker : Is || ei, E = B(e.fallbackContext) ? e.fallbackContext : void 0, R = e, W = B(R.__datetimeFormatters) ? R.__datetimeFormatters : /* @__PURE__ */ new Map(), se = B(R.__numberFormatters) ? R.__numberFormatters : /* @__PURE__ */ new Map(), ke = B(R.__meta) ? R.__meta : {};
  Ho++;
  const J = {
    version: n,
    cid: Ho,
    locale: o,
    fallbackLocale: r,
    messages: a,
    modifiers: d,
    pluralRules: v,
    missing: C,
    missingWarn: h,
    fallbackWarn: P,
    fallbackFormat: $,
    unresolving: O,
    postTranslation: S,
    processor: p,
    warnHtmlMessage: g,
    escapeParameter: L,
    messageCompiler: b,
    messageResolver: T,
    localeFallbacker: A,
    fallbackContext: E,
    onWarn: t,
    __meta: ke
  };
  return J.datetimeFormats = i, J.numberFormats = u, J.__datetimeFormatters = W, J.__numberFormatters = se, process.env.NODE_ENV !== "production" && (J.__v_emitter = R.__v_emitter != null ? R.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Xa(J, n, ke), J;
}
const Dn = (e) => ({ [e]: Y() });
function un(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Ds(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function so(e, t, n, o, s) {
  const { missing: r, onWarn: a } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: n,
      key: t,
      type: s,
      groupId: `${s}:${t}`
    });
  }
  if (r !== null) {
    const i = r(e, n, t, s);
    return x(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && Ds(o, t) && a(tt(we.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function Lt(e, t, n) {
  const o = e;
  o.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function $s(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function Ei(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let o = n + 1; o < t.length; o++)
    if ($s(e, t[o]))
      return !0;
  return !1;
}
const jo = typeof Intl < "u", Ms = {
  dateTimeFormat: jo && typeof Intl.DateTimeFormat < "u",
  numberFormat: jo && typeof Intl.NumberFormat < "u"
};
function Wo(e, ...t) {
  const { datetimeFormats: n, unresolving: o, fallbackLocale: s, onWarn: r, localeFallbacker: a } = e, { __datetimeFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !Ms.dateTimeFormat)
    return r(tt(we.CANNOT_FORMAT_DATE)), qt;
  const [u, d, v, C] = Bn(...t), h = te(v.missingWarn) ? v.missingWarn : e.missingWarn, P = te(v.fallbackWarn) ? v.fallbackWarn : e.fallbackWarn, $ = !!v.part, O = oo(e, v), S = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    O
  );
  if (!x(u) || u === "")
    return new Intl.DateTimeFormat(O, C).format(d);
  let p = {}, g, L = null, b = O, T = null;
  const A = "datetime format";
  for (let W = 0; W < S.length; W++) {
    if (g = T = S[W], process.env.NODE_ENV !== "production" && O !== g && un(P, u) && r(tt(we.FALLBACK_TO_DATE_FORMAT, {
      key: u,
      target: g
    })), process.env.NODE_ENV !== "production" && O !== g) {
      const se = e.__v_emitter;
      se && se.emit("fallback", {
        type: A,
        key: u,
        from: b,
        to: T,
        groupId: `${A}:${u}`
      });
    }
    if (p = n[g] || {}, L = p[u], U(L))
      break;
    so(e, u, g, h, A), b = T;
  }
  if (!U(L) || !x(g))
    return o ? cn : u;
  let E = `${g}__${u}`;
  ln(C) || (E = `${E}__${JSON.stringify(C)}`);
  let R = i.get(E);
  return R || (R = new Intl.DateTimeFormat(g, ae({}, L, C)), i.set(E, R)), $ ? R.formatToParts(d) : R.format(d);
}
const Rs = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Bn(...e) {
  const [t, n, o, s] = e, r = Y();
  let a = Y(), i;
  if (x(t)) {
    const u = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!u)
      throw Re(ue.INVALID_ISO_DATE_ARGUMENT);
    const d = u[3] ? u[3].trim().startsWith("T") ? `${u[1].trim()}${u[3].trim()}` : `${u[1].trim()}T${u[3].trim()}` : u[1].trim();
    i = new Date(d);
    try {
      i.toISOString();
    } catch {
      throw Re(ue.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (Zr(t)) {
    if (isNaN(t.getTime()))
      throw Re(ue.INVALID_DATE_ARGUMENT);
    i = t;
  } else if (re(t))
    i = t;
  else
    throw Re(ue.INVALID_ARGUMENT);
  return x(n) ? r.key = n : U(n) && Object.keys(n).forEach((u) => {
    Rs.includes(u) ? a[u] = n[u] : r[u] = n[u];
  }), x(o) ? r.locale = o : U(o) && (a = o), U(s) && (a = s), [r.key || "", i, r, a];
}
function Ko(e, t, n) {
  const o = e;
  for (const s in n) {
    const r = `${t}__${s}`;
    o.__datetimeFormatters.has(r) && o.__datetimeFormatters.delete(r);
  }
}
function Yo(e, ...t) {
  const { numberFormats: n, unresolving: o, fallbackLocale: s, onWarn: r, localeFallbacker: a } = e, { __numberFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !Ms.numberFormat)
    return r(tt(we.CANNOT_FORMAT_NUMBER)), qt;
  const [u, d, v, C] = Vn(...t), h = te(v.missingWarn) ? v.missingWarn : e.missingWarn, P = te(v.fallbackWarn) ? v.fallbackWarn : e.fallbackWarn, $ = !!v.part, O = oo(e, v), S = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    O
  );
  if (!x(u) || u === "")
    return new Intl.NumberFormat(O, C).format(d);
  let p = {}, g, L = null, b = O, T = null;
  const A = "number format";
  for (let W = 0; W < S.length; W++) {
    if (g = T = S[W], process.env.NODE_ENV !== "production" && O !== g && un(P, u) && r(tt(we.FALLBACK_TO_NUMBER_FORMAT, {
      key: u,
      target: g
    })), process.env.NODE_ENV !== "production" && O !== g) {
      const se = e.__v_emitter;
      se && se.emit("fallback", {
        type: A,
        key: u,
        from: b,
        to: T,
        groupId: `${A}:${u}`
      });
    }
    if (p = n[g] || {}, L = p[u], U(L))
      break;
    so(e, u, g, h, A), b = T;
  }
  if (!U(L) || !x(g))
    return o ? cn : u;
  let E = `${g}__${u}`;
  ln(C) || (E = `${E}__${JSON.stringify(C)}`);
  let R = i.get(E);
  return R || (R = new Intl.NumberFormat(g, ae({}, L, C)), i.set(E, R)), $ ? R.formatToParts(d) : R.format(d);
}
const Fs = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Vn(...e) {
  const [t, n, o, s] = e, r = Y();
  let a = Y();
  if (!re(t))
    throw Re(ue.INVALID_ARGUMENT);
  const i = t;
  return x(n) ? r.key = n : U(n) && Object.keys(n).forEach((u) => {
    Fs.includes(u) ? a[u] = n[u] : r[u] = n[u];
  }), x(o) ? r.locale = o : U(o) && (a = o), U(s) && (a = s), [r.key || "", i, r, a];
}
function Go(e, t, n) {
  const o = e;
  for (const s in n) {
    const r = `${t}__${s}`;
    o.__numberFormatters.has(r) && o.__numberFormatters.delete(r);
  }
}
const ki = (e) => e, Ci = (e) => "", Li = "text", Ti = (e) => e.length === 0 ? "" : eo(e), Ai = oa;
function qo(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function Ni(e) {
  const t = re(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (re(e.named.count) || re(e.named.n)) ? re(e.named.count) ? e.named.count : re(e.named.n) ? e.named.n : t : t;
}
function xi(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function Oi(e = {}) {
  const t = e.locale, n = Ni(e), o = B(e.pluralRules) && x(t) && z(e.pluralRules[t]) ? e.pluralRules[t] : qo, s = B(e.pluralRules) && x(t) && z(e.pluralRules[t]) ? qo : void 0, r = (p) => p[o(n, p.length, s)], a = e.list || [], i = (p) => a[p], u = e.named || Y();
  re(e.pluralIndex) && xi(n, u);
  const d = (p) => u[p];
  function v(p, g) {
    const L = z(e.messages) ? e.messages(p, !!g) : B(e.messages) ? e.messages[p] : !1;
    return L || (e.parent ? e.parent.message(p) : Ci);
  }
  const C = (p) => e.modifiers ? e.modifiers[p] : ki, h = U(e.processor) && z(e.processor.normalize) ? e.processor.normalize : Ti, P = U(e.processor) && z(e.processor.interpolate) ? e.processor.interpolate : Ai, $ = U(e.processor) && x(e.processor.type) ? e.processor.type : Li, S = {
    list: i,
    named: d,
    plural: r,
    linked: (p, ...g) => {
      const [L, b] = g;
      let T = "text", A = "";
      g.length === 1 ? B(L) ? (A = L.modifier || A, T = L.type || T) : x(L) && (A = L || A) : g.length === 2 && (x(L) && (A = L || A), x(b) && (T = b || T));
      const E = v(p, !0)(S), R = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        T === "vnode" && ne(E) && A ? E[0] : E
      );
      return A ? C(A)(R, T) : R;
    },
    message: v,
    type: $,
    interpolate: P,
    normalize: h,
    values: ae(Y(), a, u)
  };
  return S;
}
const Xo = () => "", ve = (e) => z(e);
function zo(e, ...t) {
  const { fallbackFormat: n, postTranslation: o, unresolving: s, messageCompiler: r, fallbackLocale: a, messages: i } = e, [u, d] = Hn(...t), v = te(d.missingWarn) ? d.missingWarn : e.missingWarn, C = te(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, h = te(d.escapeParameter) ? d.escapeParameter : e.escapeParameter, P = !!d.resolvedMessage, $ = x(d.default) || te(d.default) ? te(d.default) ? r ? u : () => u : d.default : n ? r ? u : () => u : null, O = n || $ != null && (x($) || z($)), S = oo(e, d);
  h && Ii(d);
  let [p, g, L] = P ? [
    u,
    S,
    i[S] || Y()
  ] : Us(e, u, S, a, C, v), b = p, T = u;
  if (!P && !(x(b) || Le(b) || ve(b)) && O && (b = $, T = b), !P && (!(x(b) || Le(b) || ve(b)) || !x(g)))
    return s ? cn : u;
  if (process.env.NODE_ENV !== "production" && x(b) && e.messageCompiler == null)
    return Ie(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${u}'.`), u;
  let A = !1;
  const E = () => {
    A = !0;
  }, R = ve(b) ? b : Bs(e, u, g, b, T, E);
  if (A)
    return b;
  const W = $i(e, g, L, d), se = Oi(W), ke = Pi(e, R, se);
  let J = o ? o(ke, u) : ke;
  if (h && x(J) && (J = ea(J)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const rt = {
      timestamp: Date.now(),
      key: x(u) ? u : ve(b) ? b.key : "",
      locale: g || (ve(b) ? b.locale : ""),
      format: x(b) ? b : ve(b) ? b.source : "",
      message: J
    };
    rt.meta = ae({}, e.__meta, /* @__PURE__ */ _i() || {}), za(rt);
  }
  return J;
}
function Ii(e) {
  ne(e.list) ? e.list = e.list.map((t) => x(t) ? Oo(t) : t) : B(e.named) && Object.keys(e.named).forEach((t) => {
    x(e.named[t]) && (e.named[t] = Oo(e.named[t]));
  });
}
function Us(e, t, n, o, s, r) {
  const { messages: a, onWarn: i, messageResolver: u, localeFallbacker: d } = e, v = d(e, o, n);
  let C = Y(), h, P = null, $ = n, O = null;
  const S = "translate";
  for (let p = 0; p < v.length; p++) {
    if (h = O = v[p], process.env.NODE_ENV !== "production" && n !== h && !$s(n, h) && un(s, t) && i(tt(we.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: h
    })), process.env.NODE_ENV !== "production" && n !== h) {
      const T = e.__v_emitter;
      T && T.emit("fallback", {
        type: S,
        key: t,
        from: $,
        to: O,
        groupId: `${S}:${t}`
      });
    }
    C = a[h] || Y();
    let g = null, L, b;
    if (process.env.NODE_ENV !== "production" && Be && (g = window.performance.now(), L = "intlify-message-resolve-start", b = "intlify-message-resolve-end", ge && ge(L)), (P = u(C, t)) === null && (P = C[t]), process.env.NODE_ENV !== "production" && Be) {
      const T = window.performance.now(), A = e.__v_emitter;
      A && g && P && A.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: P,
        time: T - g,
        groupId: `${S}:${t}`
      }), L && b && ge && et && (ge(b), et("intlify message resolve", L, b));
    }
    if (x(P) || Le(P) || ve(P))
      break;
    if (!Ei(h, v)) {
      const T = so(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        h,
        r,
        S
      );
      T !== t && (P = T);
    }
    $ = O;
  }
  return [P, h, C];
}
function Bs(e, t, n, o, s, r) {
  const { messageCompiler: a, warnHtmlMessage: i } = e;
  if (ve(o)) {
    const h = o;
    return h.locale = h.locale || n, h.key = h.key || t, h;
  }
  if (a == null) {
    const h = () => o;
    return h.locale = n, h.key = t, h;
  }
  let u = null, d, v;
  process.env.NODE_ENV !== "production" && Be && (u = window.performance.now(), d = "intlify-message-compilation-start", v = "intlify-message-compilation-end", ge && ge(d));
  const C = a(o, Si(e, n, s, o, i, r));
  if (process.env.NODE_ENV !== "production" && Be) {
    const h = window.performance.now(), P = e.__v_emitter;
    P && u && P.emit("message-compilation", {
      type: "message-compilation",
      message: o,
      time: h - u,
      groupId: `translate:${t}`
    }), d && v && ge && et && (ge(v), et("intlify message compilation", d, v));
  }
  return C.locale = n, C.key = t, C.source = o, C;
}
function Pi(e, t, n) {
  let o = null, s, r;
  process.env.NODE_ENV !== "production" && Be && (o = window.performance.now(), s = "intlify-message-evaluation-start", r = "intlify-message-evaluation-end", ge && ge(s));
  const a = t(n);
  if (process.env.NODE_ENV !== "production" && Be) {
    const i = window.performance.now(), u = e.__v_emitter;
    u && o && u.emit("message-evaluation", {
      type: "message-evaluation",
      value: a,
      time: i - o,
      groupId: `translate:${t.key}`
    }), s && r && ge && et && (ge(r), et("intlify message evaluation", s, r));
  }
  return a;
}
function Hn(...e) {
  const [t, n, o] = e, s = Y();
  if (!x(t) && !re(t) && !ve(t) && !Le(t))
    throw Re(ue.INVALID_ARGUMENT);
  const r = re(t) ? String(t) : (ve(t), t);
  return re(n) ? s.plural = n : x(n) ? s.default = n : U(n) && !ln(n) ? s.named = n : ne(n) && (s.list = n), re(o) ? s.plural = o : x(o) ? s.default = o : U(o) && ae(s, o), [r, s];
}
function Si(e, t, n, o, s, r) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: s,
    onError: (a) => {
      if (r && r(a), process.env.NODE_ENV !== "production") {
        const i = Di(o), u = `Message compilation error: ${a.message}`, d = a.location && i && sa(i, a.location.start.offset, a.location.end.offset), v = e.__v_emitter;
        v && i && v.emit("compile-error", {
          message: i,
          error: a.message,
          start: a.location && a.location.start.offset,
          end: a.location && a.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(d ? `${u}
${d}` : u);
      } else
        throw a;
    },
    onCacheKey: (a) => zr(t, n, a)
  };
}
function Di(e) {
  if (x(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function $i(e, t, n, o) {
  const { modifiers: s, pluralRules: r, messageResolver: a, fallbackLocale: i, fallbackWarn: u, missingWarn: d, fallbackContext: v } = e, h = {
    locale: t,
    modifiers: s,
    pluralRules: r,
    messages: (P, $) => {
      let O = a(n, P);
      if (O == null && (v || $)) {
        const [, , S] = Us(
          v || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          P,
          t,
          i,
          u,
          d
        );
        O = a(S, P);
      }
      if (x(O) || Le(O)) {
        let S = !1;
        const g = Bs(e, P, t, O, P, () => {
          S = !0;
        });
        return S ? Xo : g;
      } else return ve(O) ? O : Xo;
    }
  };
  return e.processor && (h.processor = e.processor), o.list && (h.list = o.list), o.named && (h.named = o.named), re(o.plural) && (h.pluralIndex = o.plural), h;
}
$a();
/*!
  * vue-i18n v11.2.8
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const Mi = "11.2.8";
function Ri() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Ze().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Ze().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Ze().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Ze().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const le = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: Za,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function xt(e, ...t) {
  return wt(e, null, process.env.NODE_ENV !== "production" ? { messages: Fi, args: t } : void 0);
}
const Fi = {
  [le.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [le.INVALID_ARGUMENT]: "Invalid argument",
  [le.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [le.NOT_INSTALLED]: "Need to install with `app.use` function",
  [le.UNEXPECTED_ERROR]: "Unexpected error",
  [le.REQUIRED_VALUE]: "Required in value: {0}",
  [le.INVALID_VALUE]: "Invalid value",
  [le.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [le.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [le.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [le.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, jn = /* @__PURE__ */ Ve("__translateVNode"), Wn = /* @__PURE__ */ Ve("__datetimeParts"), Kn = /* @__PURE__ */ Ve("__numberParts"), Yn = /* @__PURE__ */ Ve("__enableEmitter"), Gn = /* @__PURE__ */ Ve("__disableEmitter"), Ui = Ve("__setPluralRules"), Vs = /* @__PURE__ */ Ve("__injectWithOption"), qn = /* @__PURE__ */ Ve("__dispose"), Oe = {
  FALLBACK_TO_ROOT: di,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: 11,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: 12,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: 13
}, Bi = {
  [Oe.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Oe.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Oe.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [Oe.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [Oe.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [Oe.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function Xt(e, ...t) {
  return an(Bi[e], ...t);
}
function Ot(e) {
  if (!B(e) || Le(e))
    return e;
  for (const t in e)
    if (Ce(e, t))
      if (!t.includes("."))
        B(e[t]) && Ot(e[t]);
      else {
        const n = t.split("."), o = n.length - 1;
        let s = e, r = !1;
        for (let a = 0; a < o; a++) {
          if (n[a] === "__proto__")
            throw new Error(`unsafe key: ${n[a]}`);
          if (n[a] in s || (s[n[a]] = Y()), !B(s[n[a]])) {
            process.env.NODE_ENV !== "production" && Ie(Xt(Oe.IGNORE_OBJ_FLATTEN, {
              key: n[a]
            })), r = !0;
            break;
          }
          s = s[n[a]];
        }
        if (r || (Le(s) ? As.includes(n[o]) || delete e[t] : (s[n[o]] = e[t], delete e[t])), !Le(s)) {
          const a = s[n[o]];
          B(a) && Ot(a);
        }
      }
  return e;
}
function Hs(e, t) {
  const { messages: n, __i18n: o, messageResolver: s, flatJson: r } = t, a = U(n) ? n : ne(o) ? Y() : { [e]: Y() };
  if (ne(o) && o.forEach((i) => {
    if ("locale" in i && "resource" in i) {
      const { locale: u, resource: d } = i;
      u ? (a[u] = a[u] || Y(), Wt(d, a[u])) : Wt(d, a);
    } else
      x(i) && Wt(JSON.parse(i), a);
  }), s == null && r)
    for (const i in a)
      Ce(a, i) && Ot(a[i]);
  return a;
}
function js(e) {
  return e.type;
}
function Vi(e, t, n) {
  let o = B(t.messages) ? t.messages : Y();
  "__i18nGlobal" in n && (o = Hs(e.locale.value, {
    messages: o,
    __i18n: n.__i18nGlobal
  }));
  const s = Object.keys(o);
  s.length && s.forEach((r) => {
    e.mergeLocaleMessage(r, o[r]);
  });
  {
    if (B(t.datetimeFormats)) {
      const r = Object.keys(t.datetimeFormats);
      r.length && r.forEach((a) => {
        e.mergeDateTimeFormat(a, t.datetimeFormats[a]);
      });
    }
    if (B(t.numberFormats)) {
      const r = Object.keys(t.numberFormats);
      r.length && r.forEach((a) => {
        e.mergeNumberFormat(a, t.numberFormats[a]);
      });
    }
  }
}
function Jo(e) {
  return dt(Wr, null, e, 0);
}
function ro() {
  const e = "currentInstance";
  return e in In ? In[e] : In.getCurrentInstance();
}
const Zo = "__INTLIFY_META__", Qo = () => [], Hi = () => !1;
let es = 0;
function ts(e) {
  return (t, n, o, s) => e(n, o, ro() || void 0, s);
}
const ji = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = ro();
  let t = null;
  return e && (t = js(e)[Zo]) ? { [Zo]: t } : null;
};
function Wi(e = {}) {
  const { __root: t, __injectWithOption: n } = e, o = t === void 0, s = e.flatJson, r = Be ? de : jr;
  let a = te(e.inheritLocale) ? e.inheritLocale : !0;
  const i = r(
    // prettier-ignore
    t && a ? t.locale.value : x(e.locale) ? e.locale : Gt
  ), u = r(
    // prettier-ignore
    t && a ? t.fallbackLocale.value : x(e.fallbackLocale) || ne(e.fallbackLocale) || U(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i.value
  ), d = r(Hs(i.value, e)), v = r(U(e.datetimeFormats) ? e.datetimeFormats : { [i.value]: {} }), C = r(U(e.numberFormats) ? e.numberFormats : { [i.value]: {} });
  let h = t ? t.missingWarn : te(e.missingWarn) || Yt(e.missingWarn) ? e.missingWarn : !0, P = t ? t.fallbackWarn : te(e.fallbackWarn) || Yt(e.fallbackWarn) ? e.fallbackWarn : !0, $ = t ? t.fallbackRoot : te(e.fallbackRoot) ? e.fallbackRoot : !0, O = !!e.fallbackFormat, S = z(e.missing) ? e.missing : null, p = z(e.missing) ? ts(e.missing) : null, g = z(e.postTranslation) ? e.postTranslation : null, L = t ? t.warnHtmlMessage : te(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, b = !!e.escapeParameter;
  const T = t ? t.modifiers : U(e.modifiers) ? e.modifiers : {};
  let A = e.pluralRules || t && t.pluralRules, E;
  E = (() => {
    o && Vo(null);
    const w = {
      version: Mi,
      locale: i.value,
      fallbackLocale: u.value,
      messages: d.value,
      modifiers: T,
      pluralRules: A,
      missing: p === null ? void 0 : p,
      missingWarn: h,
      fallbackWarn: P,
      fallbackFormat: O,
      unresolving: !0,
      postTranslation: g === null ? void 0 : g,
      warnHtmlMessage: L,
      escapeParameter: b,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    w.datetimeFormats = v.value, w.numberFormats = C.value, w.__datetimeFormatters = U(E) ? E.__datetimeFormatters : void 0, w.__numberFormatters = U(E) ? E.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (w.__v_emitter = U(E) ? E.__v_emitter : void 0);
    const k = vi(w);
    return o && Vo(k), k;
  })(), Lt(E, i.value, u.value);
  function W() {
    return [
      i.value,
      u.value,
      d.value,
      v.value,
      C.value
    ];
  }
  const se = Ct({
    get: () => i.value,
    set: (w) => {
      E.locale = w, i.value = w;
    }
  }), ke = Ct({
    get: () => u.value,
    set: (w) => {
      E.fallbackLocale = w, u.value = w, Lt(E, i.value, w);
    }
  }), J = Ct(() => d.value), rt = /* @__PURE__ */ Ct(() => v.value), hn = /* @__PURE__ */ Ct(() => C.value);
  function gn() {
    return z(g) ? g : null;
  }
  function bn(w) {
    g = w, E.postTranslation = w;
  }
  function _n() {
    return S;
  }
  function yn(w) {
    w !== null && (p = ts(w)), S = w, E.missing = p;
  }
  function vn(w, k) {
    return w !== "translate" || !k.resolvedMessage;
  }
  const De = (w, k, H, Q, qe, Ut) => {
    W();
    let at;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (E.fallbackContext = t ? yi() : void 0), at = w(E);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (E.fallbackContext = void 0);
    }
    if (H !== "translate exists" && // for not `te` (e.g `t`)
    re(at) && at === cn || H === "translate exists" && !at) {
      const [Xe, Br] = k();
      if (process.env.NODE_ENV !== "production" && t && x(Xe) && vn(H, Br) && ($ && (un(P, Xe) || Ds(h, Xe)) && Ie(Xt(Oe.FALLBACK_TO_ROOT, {
        key: Xe,
        type: H
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Lo } = E;
        Lo && $ && Lo.emit("fallback", {
          type: H,
          key: Xe,
          to: "global",
          groupId: `${H}:${Xe}`
        });
      }
      return t && $ ? Q(t) : qe(Xe);
    } else {
      if (Ut(at))
        return at;
      throw xt(le.UNEXPECTED_RETURN_TYPE);
    }
  };
  function yt(...w) {
    return De((k) => Reflect.apply(zo, null, [k, ...w]), () => Hn(...w), "translate", (k) => Reflect.apply(k.t, k, [...w]), (k) => k, (k) => x(k));
  }
  function En(...w) {
    const [k, H, Q] = w;
    if (Q && !B(Q))
      throw xt(le.INVALID_ARGUMENT);
    return yt(k, H, ae({ resolvedMessage: !0 }, Q || {}));
  }
  function kn(...w) {
    return De((k) => Reflect.apply(Wo, null, [k, ...w]), () => Bn(...w), "datetime format", (k) => Reflect.apply(k.d, k, [...w]), () => qt, (k) => x(k) || ne(k));
  }
  function Cn(...w) {
    return De((k) => Reflect.apply(Yo, null, [k, ...w]), () => Vn(...w), "number format", (k) => Reflect.apply(k.n, k, [...w]), () => qt, (k) => x(k) || ne(k));
  }
  function Ln(w) {
    return w.map((k) => x(k) || re(k) || te(k) ? Jo(String(k)) : k);
  }
  const Tn = {
    normalize: Ln,
    interpolate: (w) => w,
    type: "vnode"
  };
  function Rt(...w) {
    return De((k) => {
      let H;
      const Q = k;
      try {
        Q.processor = Tn, H = Reflect.apply(zo, null, [Q, ...w]);
      } finally {
        Q.processor = null;
      }
      return H;
    }, () => Hn(...w), "translate", (k) => k[jn](...w), (k) => [Jo(k)], (k) => ne(k));
  }
  function An(...w) {
    return De((k) => Reflect.apply(Yo, null, [k, ...w]), () => Vn(...w), "number format", (k) => k[Kn](...w), Qo, (k) => x(k) || ne(k));
  }
  function Ft(...w) {
    return De((k) => Reflect.apply(Wo, null, [k, ...w]), () => Bn(...w), "datetime format", (k) => k[Wn](...w), Qo, (k) => x(k) || ne(k));
  }
  function Nn(w) {
    A = w, E.pluralRules = A;
  }
  function xn(w, k) {
    return De(() => {
      if (!w)
        return !1;
      const H = x(k) ? k : i.value, Q = Ge(H), qe = E.messageResolver(Q, w);
      return Le(qe) || ve(qe) || x(qe);
    }, () => [w], "translate exists", (H) => Reflect.apply(H.te, H, [w, k]), Hi, (H) => te(H));
  }
  function vt(w) {
    let k = null;
    const H = Ns(E, u.value, i.value);
    for (let Q = 0; Q < H.length; Q++) {
      const qe = d.value[H[Q]] || {}, Ut = E.messageResolver(qe, w);
      if (Ut != null) {
        k = Ut;
        break;
      }
    }
    return k;
  }
  function Et(w) {
    const k = vt(w);
    return k ?? (t ? t.tm(w) || {} : {});
  }
  function Ge(w) {
    return d.value[w] || {};
  }
  function kt(w, k) {
    if (s) {
      const H = { [w]: k };
      for (const Q in H)
        Ce(H, Q) && Ot(H[Q]);
      k = H[w];
    }
    d.value[w] = k, E.messages = d.value;
  }
  function On(w, k) {
    d.value[w] = d.value[w] || {};
    const H = { [w]: k };
    if (s)
      for (const Q in H)
        Ce(H, Q) && Ot(H[Q]);
    k = H[w], Wt(k, d.value[w]), E.messages = d.value;
  }
  function l(w) {
    return v.value[w] || {};
  }
  function c(w, k) {
    v.value[w] = k, E.datetimeFormats = v.value, Ko(E, w, k);
  }
  function y(w, k) {
    v.value[w] = ae(v.value[w] || {}, k), E.datetimeFormats = v.value, Ko(E, w, k);
  }
  function I(w) {
    return C.value[w] || {};
  }
  function X(w, k) {
    C.value[w] = k, E.numberFormats = C.value, Go(E, w, k);
  }
  function Z(w, k) {
    C.value[w] = ae(C.value[w] || {}, k), E.numberFormats = C.value, Go(E, w, k);
  }
  es++, t && Be && (To(t.locale, (w) => {
    a && (i.value = w, E.locale = w, Lt(E, i.value, u.value));
  }), To(t.fallbackLocale, (w) => {
    a && (u.value = w, E.fallbackLocale = w, Lt(E, i.value, u.value));
  }));
  const F = {
    id: es,
    locale: se,
    fallbackLocale: ke,
    get inheritLocale() {
      return a;
    },
    set inheritLocale(w) {
      a = w, w && t && (i.value = t.locale.value, u.value = t.fallbackLocale.value, Lt(E, i.value, u.value));
    },
    get availableLocales() {
      return Object.keys(d.value).sort();
    },
    messages: J,
    get modifiers() {
      return T;
    },
    get pluralRules() {
      return A || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return h;
    },
    set missingWarn(w) {
      h = w, E.missingWarn = h;
    },
    get fallbackWarn() {
      return P;
    },
    set fallbackWarn(w) {
      P = w, E.fallbackWarn = P;
    },
    get fallbackRoot() {
      return $;
    },
    set fallbackRoot(w) {
      $ = w;
    },
    get fallbackFormat() {
      return O;
    },
    set fallbackFormat(w) {
      O = w, E.fallbackFormat = O;
    },
    get warnHtmlMessage() {
      return L;
    },
    set warnHtmlMessage(w) {
      L = w, E.warnHtmlMessage = w;
    },
    get escapeParameter() {
      return b;
    },
    set escapeParameter(w) {
      b = w, E.escapeParameter = w;
    },
    t: yt,
    getLocaleMessage: Ge,
    setLocaleMessage: kt,
    mergeLocaleMessage: On,
    getPostTranslationHandler: gn,
    setPostTranslationHandler: bn,
    getMissingHandler: _n,
    setMissingHandler: yn,
    [Ui]: Nn
  };
  return F.datetimeFormats = rt, F.numberFormats = hn, F.rt = En, F.te = xn, F.tm = Et, F.d = kn, F.n = Cn, F.getDateTimeFormat = l, F.setDateTimeFormat = c, F.mergeDateTimeFormat = y, F.getNumberFormat = I, F.setNumberFormat = X, F.mergeNumberFormat = Z, F[Vs] = n, F[jn] = Rt, F[Wn] = Ft, F[Kn] = An, process.env.NODE_ENV !== "production" && (F[Yn] = (w) => {
    E.__v_emitter = w;
  }, F[Gn] = () => {
    E.__v_emitter = void 0;
  }), F;
}
function ns(e, t) {
}
const ao = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Ki({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((o, s) => [
    ...o,
    // prettier-ignore
    ...s.type === Je ? s.children : [s]
  ], []) : t.reduce((n, o) => {
    const s = e[o];
    return s && (n[o] = s()), n;
  }, Y());
}
function Ws() {
  return Je;
}
ae({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => re(e) || !isNaN(e)
  }
}, ao);
function Yi(e) {
  return ne(e) && !x(e[0]);
}
function Ks(e, t, n, o) {
  const { slots: s, attrs: r } = t;
  return () => {
    const a = { part: !0 };
    let i = Y();
    e.locale && (a.locale = e.locale), x(e.format) ? a.key = e.format : B(e.format) && (x(e.format.key) && (a.key = e.format.key), i = Object.keys(e.format).reduce((h, P) => n.includes(P) ? ae(Y(), h, { [P]: e.format[P] }) : h, Y()));
    const u = o(e.value, a, i);
    let d = [a.key];
    ne(u) ? d = u.map((h, P) => {
      const $ = s[h.type], O = $ ? $({ [h.type]: h.value, index: P, parts: u }) : [h.value];
      return Yi(O) && (O[0].key = `${h.type}-${P}`), O;
    }) : x(u) && (d = [u]);
    const v = ae(Y(), r), C = x(e.tag) || B(e.tag) ? e.tag : Ws();
    return ps(C, v, d);
  };
}
ae({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, ao);
const Gi = /* @__PURE__ */ Ve("global-vue-i18n");
function Se(e = {}) {
  const t = ro();
  if (t == null)
    throw xt(le.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw xt(le.NOT_INSTALLED);
  const n = qi(t), o = zi(n), s = js(t), r = Xi(e, s);
  if (r === "global")
    return Vi(o, e, s), o;
  if (r === "parent") {
    let u = Ji(n, t, e.__useComponent);
    return u == null && (process.env.NODE_ENV !== "production" && Ie(Xt(Oe.NOT_FOUND_PARENT_SCOPE)), u = o), u;
  }
  const a = n;
  let i = a.__getInstance(t);
  if (i == null) {
    const u = ae({}, e);
    "__i18n" in s && (u.__i18n = s.__i18n), o && (u.__root = o), i = Wi(u), a.__composerExtend && (i[qn] = a.__composerExtend(i)), Qi(a, t, i), a.__setInstance(t, i);
  } else
    process.env.NODE_ENV !== "production" && r === "local" && Ie(Xt(Oe.DUPLICATE_USE_I18N_CALLING));
  return i;
}
function qi(e) {
  const t = Vr(e.isCE ? Gi : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw xt(e.isCE ? le.NOT_INSTALLED_WITH_PROVIDE : le.UNEXPECTED_ERROR);
  return t;
}
function Xi(e, t) {
  return ln(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function zi(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function Ji(e, t, n = !1) {
  let o = null;
  const s = t.root;
  let r = Zi(t, n);
  for (; r != null; ) {
    const a = e;
    if (e.mode === "composition")
      o = a.__getInstance(r);
    else if (__VUE_I18N_LEGACY_API__) {
      const i = a.__getInstance(r);
      i != null && (o = i.__composer, n && o && !o[Vs] && (o = null));
    }
    if (o != null || s === r)
      break;
    r = r.parent;
  }
  return o;
}
function Zi(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function Qi(e, t, n) {
  let o = null;
  ws(() => {
    if (process.env.NODE_ENV !== "production") {
      t.__VUE_I18N__ = n, o = ra();
      const s = n;
      s[Yn] && s[Yn](o), o.on("*", ns);
    }
  }, t), Hr(() => {
    const s = n;
    process.env.NODE_ENV !== "production" && (o && o.off("*", ns), s[Gn] && s[Gn](), delete t.__VUE_I18N__), e.__deleteInstance(t);
    const r = s[qn];
    r && (r(), delete s[qn]);
  }, t);
}
ae({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, ao);
Ri();
wi(Ga);
hi(ui);
gi(Ns);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = Ze();
  e.__INTLIFY__ = !0, qa(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
function el(e) {
  const t = de(!1), n = de(null), o = de(!1), s = hs({
    account: "",
    password: "",
    password_old: ""
  });
  return { passwordForm: s, isUpdating: t, updateError: n, updateSuccess: o, submitPasswordChange: async () => {
    t.value = !0, n.value = null, o.value = !1;
    try {
      const a = await e.changePassword({ ...s });
      return o.value = !0, s.password = "", s.password_old = "", a;
    } catch {
      n.value = "變更密碼失敗";
    } finally {
      t.value = !1;
    }
  } };
}
const tl = { class: "w-full px-4 py-6 sm:py-10" }, nl = { class: "max-w-[min(100%,448px)] mx-auto p-6 bg-white rounded-2xl shadow-xl border border-gray-100" }, ol = { class: "mb-8" }, sl = { class: "text-2xl font-black text-gray-700" }, rl = { class: "text-gray-700" }, al = {
  key: 0,
  class: "mb-6 p-4 bg-green-50 text-green-700 rounded-lg border border-green-100 text-sm font-bold"
}, il = {
  key: 1,
  class: "mb-6 p-4 bg-red-50 text-red-700 rounded-lg border border-red-100 text-sm"
}, ll = { class: "space-y-5" }, cl = { class: "block text-sm font-bold text-gray-700 mb-2" }, ul = ["placeholder"], dl = { class: "block text-sm font-bold text-gray-700 mb-2" }, fl = { class: "relative" }, ml = ["type", "placeholder"], pl = ["aria-label"], wl = { class: "text-xl leading-none" }, hl = { class: "block text-sm font-bold text-gray-700 mb-2" }, gl = { class: "relative" }, bl = ["type", "placeholder"], _l = { class: "text-xl leading-none" }, yl = ["disabled"], vl = {
  key: 0,
  class: "text-center text-xs text-red-700 font-medium"
}, Zf = /* @__PURE__ */ Te({
  __name: "ChangePasswordPage",
  props: {
    changePasswordApi: {}
  },
  setup(e) {
    const { t } = Se(), n = e, { passwordForm: o, isUpdating: s, updateError: r, updateSuccess: a, submitPasswordChange: i } = el(n.changePasswordApi), u = async () => {
      try {
        await i();
      } catch {
      }
    }, d = de(!1);
    return (v, C) => (K(), G("div", tl, [
      f("div", nl, [
        f("header", ol, [
          f("h2", sl, N(_(t)("security.title")), 1),
          f("p", rl, N(_(t)("security.subtitle")), 1)
        ]),
        _(a) ? (K(), G("div", al, " ✅ " + N(_(t)("security.successMessage")), 1)) : Fe("", !0),
        _(r) ? (K(), G("div", il, " ❌ " + N(_(r)), 1)) : Fe("", !0),
        f("div", ll, [
          f("div", null, [
            f("label", cl, N(_(t)("security.accountLabel")), 1),
            He(f("input", {
              "onUpdate:modelValue": C[0] || (C[0] = (h) => _(o).account = h),
              type: "text",
              placeholder: _(t)("security.accountPlaceholder"),
              class: "w-full px-4 py-3 rounded-xl border border-gray-100 focus:ring-2 focus:ring-blue-700 focus:border-transparent transition outline-none text-base"
            }, null, 8, ul), [
              [it, _(o).account]
            ])
          ]),
          f("div", null, [
            f("label", dl, N(_(t)("security.oldPasswordLabel")), 1),
            f("div", fl, [
              He(f("input", {
                "onUpdate:modelValue": C[1] || (C[1] = (h) => _(o).password_old = h),
                type: d.value ? "text" : "password",
                placeholder: _(t)("security.oldPasswordPlaceholder"),
                class: "w-full px-4 py-3 pr-12 rounded-xl border border-gray-100 focus:ring-2 focus:ring-blue-700 focus:border-transparent transition outline-none text-base"
              }, null, 8, ml), [
                [Ao, _(o).password_old]
              ]),
              f("button", {
                type: "button",
                onClick: C[2] || (C[2] = (h) => d.value = !d.value),
                class: "absolute right-0 top-0 h-full px-4 flex items-center justify-center text-gray-700 active:text-gray-700 transition-colors select-none",
                "aria-label": _(t)("security.togglePassword")
              }, [
                f("span", wl, N(d.value ? "🙈" : "👁️"), 1)
              ], 8, pl)
            ])
          ]),
          f("div", null, [
            f("label", hl, N(_(t)("security.newPasswordLabel")), 1),
            f("div", gl, [
              He(f("input", {
                "onUpdate:modelValue": C[3] || (C[3] = (h) => _(o).password = h),
                type: d.value ? "text" : "password",
                placeholder: _(t)("security.newPasswordPlaceholder"),
                class: "w-full px-4 py-3 pr-12 rounded-xl border border-gray-100 focus:ring-2 focus:ring-blue-700 focus:border-transparent transition outline-none text-base"
              }, null, 8, bl), [
                [Ao, _(o).password]
              ]),
              f("button", {
                type: "button",
                onClick: C[4] || (C[4] = (h) => d.value = !d.value),
                class: "absolute right-0 top-0 h-full px-4 flex items-center justify-center text-gray-700 active:text-gray-700 transition-colors select-none"
              }, [
                f("span", _l, N(d.value ? "🙈" : "👁️"), 1)
              ])
            ])
          ]),
          f("button", {
            onClick: u,
            disabled: _(s) || !_(o).account || !_(o).password || !_(o).password_old,
            class: "w-full py-4 rounded-xl font-bold transition-all bg-blue-700 text-white disabled:bg-gray-100 disabled:text-gray-400 active:scale-[0.98]"
          }, N(_(s) ? _(t)("common.processing") : _(t)("security.submitBtn")), 9, yl),
          !_(s) && (!_(o).account || !_(o).password || !_(o).password_old) ? (K(), G("p", vl, " * " + N(_(t)("security.requiredFieldsNote")), 1)) : Fe("", !0)
        ])
      ])
    ]));
  }
});
function El(e) {
  const t = de([]), n = de([]), o = de(!1), s = de(null);
  return {
    userList: t,
    adminNames: n,
    loading: o,
    error: s,
    fetchUsers: async () => {
      o.value = !0, s.value = null;
      try {
        const i = await e.getUsersByMerchant();
        t.value = i.users, n.value = i.merchantAdminNames;
      } catch (i) {
        s.value = i.message || "Failed to fetch merchant users";
      } finally {
        o.value = !1;
      }
    },
    toggleUserStatus: async (i) => {
      if (!i.userInfo) {
        s.value = "此使用者尚未建立設定檔";
        return;
      }
      const u = i.userInfo.enabled;
      try {
        i.userInfo.enabled = !i.userInfo.enabled, await e.updateUserStatus(i.username, i.userInfo.enabled);
      } catch (d) {
        i.userInfo.enabled = u, s.value = d.message || "無法更新狀態";
      }
    }
  };
}
/*!
* sweetalert2 v11.26.10
* Released under the MIT License.
*/
function Ys(e, t, n) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function kl(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function os(e, t) {
  return e.get(Ys(e, t));
}
function Cl(e, t, n) {
  kl(e, t), t.set(e, n);
}
function Ll(e, t, n) {
  return e.set(Ys(e, t), n), n;
}
const Tl = 100, D = {}, Al = () => {
  D.previousActiveElement instanceof HTMLElement ? (D.previousActiveElement.focus(), D.previousActiveElement = null) : document.body && document.body.focus();
}, Nl = (e) => new Promise((t) => {
  if (!e)
    return t();
  const n = window.scrollX, o = window.scrollY;
  D.restoreFocusTimeout = setTimeout(() => {
    Al(), t();
  }, Tl), window.scrollTo(n, o);
}), Gs = "swal2-", xl = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], m = xl.reduce(
  (e, t) => (e[t] = Gs + t, e),
  /** @type {SwalClasses} */
  {}
), Ol = ["success", "warning", "info", "question", "error"], zt = Ol.reduce(
  (e, t) => (e[t] = Gs + t, e),
  /** @type {SwalIcons} */
  {}
), qs = "SweetAlert2:", io = (e) => e.charAt(0).toUpperCase() + e.slice(1), me = (e) => {
  console.warn(`${qs} ${typeof e == "object" ? e.join(" ") : e}`);
}, ot = (e) => {
  console.error(`${qs} ${e}`);
}, ss = [], Il = (e) => {
  ss.includes(e) || (ss.push(e), me(e));
}, Xs = (e, t = null) => {
  Il(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, dn = (e) => typeof e == "function" ? e() : e, lo = (e) => e && typeof e.toPromise == "function", It = (e) => lo(e) ? e.toPromise() : Promise.resolve(e), co = (e) => e && Promise.resolve(e) === e, pe = () => document.body.querySelector(`.${m.container}`), Pt = (e) => {
  const t = pe();
  return t ? t.querySelector(e) : null;
}, _e = (e) => Pt(`.${e}`), V = () => _e(m.popup), ht = () => _e(m.icon), Pl = () => _e(m["icon-content"]), zs = () => _e(m.title), uo = () => _e(m["html-container"]), Js = () => _e(m.image), fo = () => _e(m["progress-steps"]), fn = () => _e(m["validation-message"]), Pe = () => (
  /** @type {HTMLButtonElement} */
  Pt(`.${m.actions} .${m.confirm}`)
), gt = () => (
  /** @type {HTMLButtonElement} */
  Pt(`.${m.actions} .${m.cancel}`)
), st = () => (
  /** @type {HTMLButtonElement} */
  Pt(`.${m.actions} .${m.deny}`)
), Sl = () => _e(m["input-label"]), bt = () => Pt(`.${m.loader}`), St = () => _e(m.actions), Zs = () => _e(m.footer), mn = () => _e(m["timer-progress-bar"]), mo = () => _e(m.close), Dl = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, po = () => {
  const e = V();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((r, a) => {
    const i = parseInt(r.getAttribute("tabindex") || "0"), u = parseInt(a.getAttribute("tabindex") || "0");
    return i > u ? 1 : i < u ? -1 : 0;
  }), o = e.querySelectorAll(Dl), s = Array.from(o).filter((r) => r.getAttribute("tabindex") !== "-1");
  return [...new Set(n.concat(s))].filter((r) => he(r));
}, wo = () => Ue(document.body, m.shown) && !Ue(document.body, m["toast-shown"]) && !Ue(document.body, m["no-backdrop"]), pn = () => {
  const e = V();
  return e ? Ue(e, m.toast) : !1;
}, $l = () => {
  const e = V();
  return e ? e.hasAttribute("data-loading") : !1;
}, ye = (e, t) => {
  if (e.textContent = "", t) {
    const o = new DOMParser().parseFromString(t, "text/html"), s = o.querySelector("head");
    s && Array.from(s.childNodes).forEach((a) => {
      e.appendChild(a);
    });
    const r = o.querySelector("body");
    r && Array.from(r.childNodes).forEach((a) => {
      a instanceof HTMLVideoElement || a instanceof HTMLAudioElement ? e.appendChild(a.cloneNode(!0)) : e.appendChild(a);
    });
  }
}, Ue = (e, t) => {
  if (!t)
    return !1;
  const n = t.split(/\s+/);
  for (let o = 0; o < n.length; o++)
    if (!e.classList.contains(n[o]))
      return !1;
  return !0;
}, Ml = (e, t) => {
  Array.from(e.classList).forEach((n) => {
    !Object.values(m).includes(n) && !Object.values(zt).includes(n) && !Object.values(t.showClass || {}).includes(n) && e.classList.remove(n);
  });
}, be = (e, t, n) => {
  if (Ml(e, t), !t.customClass)
    return;
  const o = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    n
  ];
  if (o) {
    if (typeof o != "string" && !o.forEach) {
      me(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`);
      return;
    }
    j(e, o);
  }
}, wn = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${m.popup} > .${m[t]}`);
    case "checkbox":
      return e.querySelector(`.${m.popup} > .${m.checkbox} input`);
    case "radio":
      return e.querySelector(`.${m.popup} > .${m.radio} input:checked`) || e.querySelector(`.${m.popup} > .${m.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${m.popup} > .${m.range} input`);
    default:
      return e.querySelector(`.${m.popup} > .${m.input}`);
  }
}, Qs = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, er = (e, t, n) => {
  !e || !t || (typeof t == "string" && (t = t.split(/\s+/).filter(Boolean)), t.forEach((o) => {
    Array.isArray(e) ? e.forEach((s) => {
      n ? s.classList.add(o) : s.classList.remove(o);
    }) : n ? e.classList.add(o) : e.classList.remove(o);
  }));
}, j = (e, t) => {
  er(e, t, !0);
}, Ee = (e, t) => {
  er(e, t, !1);
}, je = (e, t) => {
  const n = Array.from(e.children);
  for (let o = 0; o < n.length; o++) {
    const s = n[o];
    if (s instanceof HTMLElement && Ue(s, t))
      return s;
  }
}, Qe = (e, t, n) => {
  n === `${parseInt(`${n}`)}` && (n = parseInt(n)), n || parseInt(`${n}`) === 0 ? e.style.setProperty(t, typeof n == "number" ? `${n}px` : n) : e.style.removeProperty(t);
}, ie = (e, t = "flex") => {
  e && (e.style.display = t);
}, fe = (e) => {
  e && (e.style.display = "none");
}, ho = (e, t = "block") => {
  e && new MutationObserver(() => {
    Dt(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, rs = (e, t, n, o) => {
  const s = e.querySelector(t);
  s && s.style.setProperty(n, o);
}, Dt = (e, t, n = "flex") => {
  t ? ie(e, n) : fe(e);
}, he = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), Rl = () => !he(Pe()) && !he(st()) && !he(gt()), Xn = (e) => e.scrollHeight > e.clientHeight, Fl = (e, t) => {
  let n = e;
  for (; n && n !== t; ) {
    if (Xn(n))
      return !0;
    n = n.parentElement;
  }
  return !1;
}, tr = (e) => {
  const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), o = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return n > 0 || o > 0;
}, go = (e, t = !1) => {
  const n = mn();
  n && he(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(() => {
    n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
  }, 10));
}, Ul = () => {
  const e = mn();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const n = parseInt(window.getComputedStyle(e).width), o = t / n * 100;
  e.style.width = `${o}%`;
}, Bl = () => typeof window > "u" || typeof document > "u", Vl = `
 <div aria-labelledby="${m.title}" aria-describedby="${m["html-container"]}" class="${m.popup}" tabindex="-1">
   <button type="button" class="${m.close}"></button>
   <ul class="${m["progress-steps"]}"></ul>
   <div class="${m.icon}"></div>
   <img class="${m.image}" />
   <h2 class="${m.title}" id="${m.title}"></h2>
   <div class="${m["html-container"]}" id="${m["html-container"]}"></div>
   <input class="${m.input}" id="${m.input}" />
   <input type="file" class="${m.file}" />
   <div class="${m.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${m.select}" id="${m.select}"></select>
   <div class="${m.radio}"></div>
   <label class="${m.checkbox}">
     <input type="checkbox" id="${m.checkbox}" />
     <span class="${m.label}"></span>
   </label>
   <textarea class="${m.textarea}" id="${m.textarea}"></textarea>
   <div class="${m["validation-message"]}" id="${m["validation-message"]}"></div>
   <div class="${m.actions}">
     <div class="${m.loader}"></div>
     <button type="button" class="${m.confirm}"></button>
     <button type="button" class="${m.deny}"></button>
     <button type="button" class="${m.cancel}"></button>
   </div>
   <div class="${m.footer}"></div>
   <div class="${m["timer-progress-bar-container"]}">
     <div class="${m["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), Hl = () => {
  const e = pe();
  return e ? (e.remove(), Ee([document.documentElement, document.body], [m["no-backdrop"], m["toast-shown"], m["has-column"]]), !0) : !1;
}, ze = () => {
  D.currentInstance.resetValidationMessage();
}, jl = () => {
  const e = V(), t = je(e, m.input), n = je(e, m.file), o = e.querySelector(`.${m.range} input`), s = e.querySelector(`.${m.range} output`), r = je(e, m.select), a = e.querySelector(`.${m.checkbox} input`), i = je(e, m.textarea);
  t.oninput = ze, n.onchange = ze, r.onchange = ze, a.onchange = ze, i.oninput = ze, o.oninput = () => {
    ze(), s.value = o.value;
  }, o.onchange = () => {
    ze(), s.value = o.value;
  };
}, Wl = (e) => typeof e == "string" ? document.querySelector(e) : e, Kl = (e) => {
  const t = V();
  t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true");
}, Yl = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (j(pe(), m.rtl), D.isRTL = !0);
}, Gl = (e) => {
  const t = Hl();
  if (Bl()) {
    ot("SweetAlert2 requires document to initialize");
    return;
  }
  const n = document.createElement("div");
  n.className = m.container, t && j(n, m["no-transition"]), ye(n, Vl), n.dataset.swal2Theme = e.theme;
  const o = Wl(e.target);
  o.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), Kl(e), Yl(o), jl();
}, bo = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? ql(e, t) : e && ye(t, e);
}, ql = (e, t) => {
  e.jquery ? Xl(t, e) : ye(t, e.toString());
}, Xl = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let n = 0; n in t; n++)
      e.appendChild(t[n].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, zl = (e, t) => {
  const n = St(), o = bt();
  !n || !o || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? fe(n) : ie(n), be(n, t, "actions"), Jl(n, o, t), ye(o, t.loaderHtml || ""), be(o, t, "loader"));
};
function Jl(e, t, n) {
  const o = Pe(), s = st(), r = gt();
  !o || !s || !r || (Mn(o, "confirm", n), Mn(s, "deny", n), Mn(r, "cancel", n), Zl(o, s, r, n), n.reverseButtons && (n.toast ? (e.insertBefore(r, o), e.insertBefore(s, o)) : (e.insertBefore(r, t), e.insertBefore(s, t), e.insertBefore(o, t))));
}
function Zl(e, t, n, o) {
  if (!o.buttonsStyling) {
    Ee([e, t, n], m.styled);
    return;
  }
  j([e, t, n], m.styled), o.confirmButtonColor && e.style.setProperty("--swal2-confirm-button-background-color", o.confirmButtonColor), o.denyButtonColor && t.style.setProperty("--swal2-deny-button-background-color", o.denyButtonColor), o.cancelButtonColor && n.style.setProperty("--swal2-cancel-button-background-color", o.cancelButtonColor), $n(e), $n(t), $n(n);
}
function $n(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
}
function Mn(e, t, n) {
  const o = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    io(t)
  );
  Dt(e, n[`show${o}Button`], "inline-block"), ye(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = m[t], be(e, n, `${t}Button`);
}
const Ql = (e, t) => {
  const n = mo();
  n && (ye(n, t.closeButtonHtml || ""), be(n, t, "closeButton"), Dt(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, ec = (e, t) => {
  const n = pe();
  n && (tc(n, t.backdrop), nc(n, t.position), oc(n, t.grow), be(n, t, "container"));
};
function tc(e, t) {
  typeof t == "string" ? e.style.background = t : t || j([document.documentElement, document.body], m["no-backdrop"]);
}
function nc(e, t) {
  t && (t in m ? j(e, m[t]) : (me('The "position" parameter is not valid, defaulting to "center"'), j(e, m.center)));
}
function oc(e, t) {
  t && j(e, m[`grow-${t}`]);
}
var q = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap()
};
const sc = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], rc = (e, t) => {
  const n = V();
  if (!n)
    return;
  const o = q.innerParams.get(e), s = !o || t.input !== o.input;
  sc.forEach((r) => {
    const a = je(n, m[r]);
    a && (lc(r, t.inputAttributes), a.className = m[r], s && fe(a));
  }), t.input && (s && ac(t), cc(t));
}, ac = (e) => {
  if (!e.input)
    return;
  if (!ee[e.input]) {
    ot(`Unexpected type of input! Expected ${Object.keys(ee).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = nr(e.input);
  if (!t)
    return;
  const n = ee[e.input](t, e);
  ie(t), e.inputAutoFocus && setTimeout(() => {
    Qs(n);
  });
}, ic = (e) => {
  for (let t = 0; t < e.attributes.length; t++) {
    const n = e.attributes[t].name;
    ["id", "type", "value", "style"].includes(n) || e.removeAttribute(n);
  }
}, lc = (e, t) => {
  const n = V();
  if (!n)
    return;
  const o = wn(n, e);
  if (o) {
    ic(o);
    for (const s in t)
      o.setAttribute(s, t[s]);
  }
}, cc = (e) => {
  if (!e.input)
    return;
  const t = nr(e.input);
  t && be(t, e, "input");
}, _o = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, $t = (e, t, n) => {
  if (n.inputLabel) {
    const o = document.createElement("label"), s = m["input-label"];
    o.setAttribute("for", e.id), o.className = s, typeof n.customClass == "object" && j(o, n.customClass.inputLabel), o.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", o);
  }
}, nr = (e) => {
  const t = V();
  if (t)
    return je(t, m[
      /** @type {SwalClass} */
      e
    ] || m.input);
}, Jt = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : co(t) || me(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, ee = {};
ee.text = ee.email = ee.password = ee.number = ee.tel = ee.url = ee.search = ee.date = ee["datetime-local"] = ee.time = ee.week = ee.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => (Jt(e, t.inputValue), $t(e, e, t), _o(e, t), e.type = t.input, e);
ee.file = (e, t) => ($t(e, e, t), _o(e, t), e);
ee.range = (e, t) => {
  const n = e.querySelector("input"), o = e.querySelector("output");
  return Jt(n, t.inputValue), n.type = t.input, Jt(o, t.inputValue), $t(n, e, t), e;
};
ee.select = (e, t) => {
  if (e.textContent = "", t.inputPlaceholder) {
    const n = document.createElement("option");
    ye(n, t.inputPlaceholder), n.value = "", n.disabled = !0, n.selected = !0, e.appendChild(n);
  }
  return $t(e, e, t), e;
};
ee.radio = (e) => (e.textContent = "", e);
ee.checkbox = (e, t) => {
  const n = wn(V(), "checkbox");
  n.value = "1", n.checked = !!t.inputValue;
  const o = e.querySelector("span");
  return ye(o, t.inputPlaceholder || t.inputLabel), n;
};
ee.textarea = (e, t) => {
  Jt(e, t.inputValue), _o(e, t), $t(e, e, t);
  const n = (o) => parseInt(window.getComputedStyle(o).marginLeft) + parseInt(window.getComputedStyle(o).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const o = parseInt(window.getComputedStyle(V()).width), s = () => {
        if (!document.body.contains(e))
          return;
        const r = e.offsetWidth + n(e);
        r > o ? V().style.width = `${r}px` : Qe(V(), "width", t.width);
      };
      new MutationObserver(s).observe(e, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), e;
};
const uc = (e, t) => {
  const n = uo();
  n && (ho(n), be(n, t, "htmlContainer"), t.html ? (bo(t.html, n), ie(n, "block")) : t.text ? (n.textContent = t.text, ie(n, "block")) : fe(n), rc(e, t));
}, dc = (e, t) => {
  const n = Zs();
  n && (ho(n), Dt(n, !!t.footer, "block"), t.footer && bo(t.footer, n), be(n, t, "footer"));
}, fc = (e, t) => {
  const n = q.innerParams.get(e), o = ht();
  if (!o)
    return;
  if (n && t.icon === n.icon) {
    is(o, t), as(o, t);
    return;
  }
  if (!t.icon && !t.iconHtml) {
    fe(o);
    return;
  }
  if (t.icon && Object.keys(zt).indexOf(t.icon) === -1) {
    ot(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), fe(o);
    return;
  }
  ie(o), is(o, t), as(o, t), j(o, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", or);
}, as = (e, t) => {
  for (const [n, o] of Object.entries(zt))
    t.icon !== n && Ee(e, o);
  j(e, t.icon && zt[t.icon]), wc(e, t), or(), be(e, t, "icon");
}, or = () => {
  const e = V();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color"), n = e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
  for (let o = 0; o < n.length; o++)
    n[o].style.backgroundColor = t;
}, mc = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, pc = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, is = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let n = e.innerHTML, o = "";
  t.iconHtml ? o = ls(t.iconHtml) : t.icon === "success" ? (o = mc(t), n = n.replace(/ style=".*?"/g, "")) : t.icon === "error" ? o = pc : t.icon && (o = ls({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), n.trim() !== o.trim() && ye(e, o);
}, wc = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const n of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      rs(e, n, "background-color", t.iconColor);
    rs(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, ls = (e) => `<div class="${m["icon-content"]}">${e}</div>`, hc = (e, t) => {
  const n = Js();
  if (n) {
    if (!t.imageUrl) {
      fe(n);
      return;
    }
    ie(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), Qe(n, "width", t.imageWidth), Qe(n, "height", t.imageHeight), n.className = m.image, be(n, t, "image");
  }
};
let yo = !1, sr = 0, rr = 0, ar = 0, ir = 0;
const gc = (e) => {
  e.addEventListener("mousedown", Zt), document.body.addEventListener("mousemove", Qt), e.addEventListener("mouseup", en), e.addEventListener("touchstart", Zt), document.body.addEventListener("touchmove", Qt), e.addEventListener("touchend", en);
}, bc = (e) => {
  e.removeEventListener("mousedown", Zt), document.body.removeEventListener("mousemove", Qt), e.removeEventListener("mouseup", en), e.removeEventListener("touchstart", Zt), document.body.removeEventListener("touchmove", Qt), e.removeEventListener("touchend", en);
}, Zt = (e) => {
  const t = V();
  if (e.target === t || ht().contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    yo = !0;
    const n = lr(e);
    sr = n.clientX, rr = n.clientY, ar = parseInt(t.style.insetInlineStart) || 0, ir = parseInt(t.style.insetBlockStart) || 0, j(t, "swal2-dragging");
  }
}, Qt = (e) => {
  const t = V();
  if (yo) {
    let {
      clientX: n,
      clientY: o
    } = lr(e);
    const s = n - sr;
    t.style.insetInlineStart = `${ar + (D.isRTL ? -s : s)}px`, t.style.insetBlockStart = `${ir + (o - rr)}px`;
  }
}, en = () => {
  const e = V();
  yo = !1, Ee(e, "swal2-dragging");
}, lr = (e) => {
  let t = 0, n = 0;
  return e.type.startsWith("mouse") ? (t = /** @type {MouseEvent} */
  e.clientX, n = /** @type {MouseEvent} */
  e.clientY) : e.type.startsWith("touch") && (t = /** @type {TouchEvent} */
  e.touches[0].clientX, n = /** @type {TouchEvent} */
  e.touches[0].clientY), {
    clientX: t,
    clientY: n
  };
}, _c = (e, t) => {
  const n = pe(), o = V();
  if (!(!n || !o)) {
    if (t.toast) {
      Qe(n, "width", t.width), o.style.width = "100%";
      const s = bt();
      s && o.insertBefore(s, ht());
    } else
      Qe(o, "width", t.width);
    Qe(o, "padding", t.padding), t.color && (o.style.color = t.color), t.background && (o.style.background = t.background), fe(fn()), yc(o, t), t.draggable && !t.toast ? (j(o, m.draggable), gc(o)) : (Ee(o, m.draggable), bc(o));
  }
}, yc = (e, t) => {
  const n = t.showClass || {};
  e.className = `${m.popup} ${he(e) ? n.popup : ""}`, t.toast ? (j([document.documentElement, document.body], m["toast-shown"]), j(e, m.toast)) : j(e, m.modal), be(e, t, "popup"), typeof t.customClass == "string" && j(e, t.customClass), t.icon && j(e, m[`icon-${t.icon}`]);
}, vc = (e, t) => {
  const n = fo();
  if (!n)
    return;
  const {
    progressSteps: o,
    currentProgressStep: s
  } = t;
  if (!o || o.length === 0 || s === void 0) {
    fe(n);
    return;
  }
  ie(n), n.textContent = "", s >= o.length && me("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), o.forEach((r, a) => {
    const i = Ec(r);
    if (n.appendChild(i), a === s && j(i, m["active-progress-step"]), a !== o.length - 1) {
      const u = kc(t);
      n.appendChild(u);
    }
  });
}, Ec = (e) => {
  const t = document.createElement("li");
  return j(t, m["progress-step"]), ye(t, e), t;
}, kc = (e) => {
  const t = document.createElement("li");
  return j(t, m["progress-step-line"]), e.progressStepsDistance && Qe(t, "width", e.progressStepsDistance), t;
}, Cc = (e, t) => {
  const n = zs();
  n && (ho(n), Dt(n, !!(t.title || t.titleText), "block"), t.title && bo(t.title, n), t.titleText && (n.innerText = t.titleText), be(n, t, "title"));
}, cr = (e, t) => {
  _c(e, t), ec(e, t), vc(e, t), fc(e, t), hc(e, t), Cc(e, t), Ql(e, t), uc(e, t), zl(e, t), dc(e, t);
  const n = V();
  typeof t.didRender == "function" && n && t.didRender(n), D.eventEmitter.emit("didRender", n);
}, Lc = () => he(V()), ur = () => {
  var e;
  return (e = Pe()) === null || e === void 0 ? void 0 : e.click();
}, Tc = () => {
  var e;
  return (e = st()) === null || e === void 0 ? void 0 : e.click();
}, Ac = () => {
  var e;
  return (e = gt()) === null || e === void 0 ? void 0 : e.click();
}, _t = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), dr = (e) => {
  e.keydownTarget && e.keydownHandlerAdded && (e.keydownTarget.removeEventListener("keydown", e.keydownHandler, {
    capture: e.keydownListenerCapture
  }), e.keydownHandlerAdded = !1);
}, Nc = (e, t, n) => {
  dr(e), t.toast || (e.keydownHandler = (o) => Oc(t, o, n), e.keydownTarget = t.keydownListenerCapture ? window : V(), e.keydownListenerCapture = t.keydownListenerCapture, e.keydownTarget.addEventListener("keydown", e.keydownHandler, {
    capture: e.keydownListenerCapture
  }), e.keydownHandlerAdded = !0);
}, zn = (e, t) => {
  var n;
  const o = po();
  if (o.length) {
    e = e + t, e === -2 && (e = o.length - 1), e === o.length ? e = 0 : e === -1 && (e = o.length - 1), o[e].focus();
    return;
  }
  (n = V()) === null || n === void 0 || n.focus();
}, fr = ["ArrowRight", "ArrowDown"], xc = ["ArrowLeft", "ArrowUp"], Oc = (e, t, n) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? Ic(t, e) : t.key === "Tab" ? Pc(t) : [...fr, ...xc].includes(t.key) ? Sc(t.key) : t.key === "Escape" && Dc(t, e, n)));
}, Ic = (e, t) => {
  if (!dn(t.allowEnterKey))
    return;
  const n = wn(V(), t.input);
  if (e.target && n && e.target instanceof HTMLElement && e.target.outerHTML === n.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    ur(), e.preventDefault();
  }
}, Pc = (e) => {
  const t = e.target, n = po();
  let o = -1;
  for (let s = 0; s < n.length; s++)
    if (t === n[s]) {
      o = s;
      break;
    }
  e.shiftKey ? zn(o, -1) : zn(o, 1), e.stopPropagation(), e.preventDefault();
}, Sc = (e) => {
  const t = St(), n = Pe(), o = st(), s = gt();
  if (!t || !n || !o || !s)
    return;
  const r = [n, o, s];
  if (document.activeElement instanceof HTMLElement && !r.includes(document.activeElement))
    return;
  const a = fr.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let i = document.activeElement;
  if (i) {
    for (let u = 0; u < t.children.length; u++) {
      if (i = i[a], !i)
        return;
      if (i instanceof HTMLButtonElement && he(i))
        break;
    }
    i instanceof HTMLButtonElement && i.focus();
  }
}, Dc = (e, t, n) => {
  e.preventDefault(), dn(t.allowEscapeKey) && n(_t.esc);
};
var mt = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const $c = () => {
  const e = pe();
  Array.from(document.body.children).forEach((n) => {
    n.contains(e) || (n.hasAttribute("aria-hidden") && n.setAttribute("data-previous-aria-hidden", n.getAttribute("aria-hidden") || ""), n.setAttribute("aria-hidden", "true"));
  });
}, mr = () => {
  Array.from(document.body.children).forEach((t) => {
    t.hasAttribute("data-previous-aria-hidden") ? (t.setAttribute("aria-hidden", t.getAttribute("data-previous-aria-hidden") || ""), t.removeAttribute("data-previous-aria-hidden")) : t.removeAttribute("aria-hidden");
  });
}, pr = typeof window < "u" && !!window.GestureEvent, Mc = () => {
  if (pr && !Ue(document.body, m.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, j(document.body, m.iosfix), Rc();
  }
}, Rc = () => {
  const e = pe();
  if (!e)
    return;
  let t;
  e.ontouchstart = (n) => {
    t = Fc(n);
  }, e.ontouchmove = (n) => {
    t && (n.preventDefault(), n.stopPropagation());
  };
}, Fc = (e) => {
  const t = e.target, n = pe(), o = uo();
  return !n || !o || Uc(e) || Bc(e) ? !1 : t === n || !Xn(n) && t instanceof HTMLElement && !Fl(t, o) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(Xn(o) && // #1944
  o.contains(t));
}, Uc = (e) => e.touches && e.touches.length && e.touches[0].touchType === "stylus", Bc = (e) => e.touches && e.touches.length > 1, Vc = () => {
  if (Ue(document.body, m.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    Ee(document.body, m.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, Hc = () => {
  const e = document.createElement("div");
  e.className = m["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let ct = null;
const jc = (e) => {
  ct === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (ct = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${ct + Hc()}px`);
}, Wc = () => {
  ct !== null && (document.body.style.paddingRight = `${ct}px`, ct = null);
};
function wr(e, t, n, o) {
  pn() ? cs(e, o) : (Nl(n).then(() => cs(e, o)), dr(D)), pr ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), wo() && (Wc(), Vc(), mr()), Kc();
}
function Kc() {
  Ee([document.documentElement, document.body], [m.shown, m["height-auto"], m["no-backdrop"], m["toast-shown"]]);
}
function We(e) {
  e = Gc(e);
  const t = mt.swalPromiseResolve.get(this), n = Yc(this);
  this.isAwaitingPromise ? e.isDismissed || (Mt(this), t(e)) : n && t(e);
}
const Yc = (e) => {
  const t = V();
  if (!t)
    return !1;
  const n = q.innerParams.get(e);
  if (!n || Ue(t, n.hideClass.popup))
    return !1;
  Ee(t, n.showClass.popup), j(t, n.hideClass.popup);
  const o = pe();
  return Ee(o, n.showClass.backdrop), j(o, n.hideClass.backdrop), qc(e, t, n), !0;
};
function hr(e) {
  const t = mt.swalPromiseReject.get(this);
  Mt(this), t && t(e);
}
const Mt = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, q.innerParams.get(e) || e._destroy());
}, Gc = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), qc = (e, t, n) => {
  var o;
  const s = pe(), r = tr(t);
  typeof n.willClose == "function" && n.willClose(t), (o = D.eventEmitter) === null || o === void 0 || o.emit("willClose", t), r ? Xc(e, t, s, n.returnFocus, n.didClose) : wr(e, s, n.returnFocus, n.didClose);
}, Xc = (e, t, n, o, s) => {
  D.swalCloseEventFinishedCallback = wr.bind(null, e, n, o, s);
  const r = function(a) {
    if (a.target === t) {
      var i;
      (i = D.swalCloseEventFinishedCallback) === null || i === void 0 || i.call(D), delete D.swalCloseEventFinishedCallback, t.removeEventListener("animationend", r), t.removeEventListener("transitionend", r);
    }
  };
  t.addEventListener("animationend", r), t.addEventListener("transitionend", r);
}, cs = (e, t) => {
  setTimeout(() => {
    var n;
    typeof t == "function" && t.bind(e.params)(), (n = D.eventEmitter) === null || n === void 0 || n.emit("didClose"), e._destroy && e._destroy();
  });
}, pt = (e) => {
  let t = V();
  if (t || new rn(), t = V(), !t)
    return;
  const n = bt();
  pn() ? fe(ht()) : zc(t, e), ie(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, zc = (e, t) => {
  const n = St(), o = bt();
  !n || !o || (!t && he(Pe()) && (t = Pe()), ie(n), t && (fe(t), o.setAttribute("data-button-to-replace", t.className), n.insertBefore(o, t)), j([e, n], m.loading));
}, Jc = (e, t) => {
  t.input === "select" || t.input === "radio" ? nu(e, t) : ["text", "email", "number", "tel", "textarea"].some((n) => n === t.input) && (lo(t.inputValue) || co(t.inputValue)) && (pt(Pe()), ou(e, t));
}, Zc = (e, t) => {
  const n = e.getInput();
  if (!n)
    return null;
  switch (t.input) {
    case "checkbox":
      return Qc(n);
    case "radio":
      return eu(n);
    case "file":
      return tu(n);
    default:
      return t.inputAutoTrim ? n.value.trim() : n.value;
  }
}, Qc = (e) => e.checked ? 1 : 0, eu = (e) => e.checked ? e.value : null, tu = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, nu = (e, t) => {
  const n = V();
  if (!n)
    return;
  const o = (s) => {
    t.input === "select" ? su(n, tn(s), t) : t.input === "radio" && ru(n, tn(s), t);
  };
  lo(t.inputOptions) || co(t.inputOptions) ? (pt(Pe()), It(t.inputOptions).then((s) => {
    e.hideLoading(), o(s);
  })) : typeof t.inputOptions == "object" ? o(t.inputOptions) : ot(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, ou = (e, t) => {
  const n = e.getInput();
  n && (fe(n), It(t.inputValue).then((o) => {
    n.value = t.input === "number" ? `${parseFloat(o) || 0}` : `${o}`, ie(n), n.focus(), e.hideLoading();
  }).catch((o) => {
    ot(`Error in inputValue promise: ${o}`), n.value = "", ie(n), n.focus(), e.hideLoading();
  }));
};
function su(e, t, n) {
  const o = je(e, m.select);
  if (!o)
    return;
  const s = (r, a, i) => {
    const u = document.createElement("option");
    u.value = i, ye(u, a), u.selected = gr(i, n.inputValue), r.appendChild(u);
  };
  t.forEach((r) => {
    const a = r[0], i = r[1];
    if (Array.isArray(i)) {
      const u = document.createElement("optgroup");
      u.label = a, u.disabled = !1, o.appendChild(u), i.forEach((d) => s(u, d[1], d[0]));
    } else
      s(o, i, a);
  }), o.focus();
}
function ru(e, t, n) {
  const o = je(e, m.radio);
  if (!o)
    return;
  t.forEach((r) => {
    const a = r[0], i = r[1], u = document.createElement("input"), d = document.createElement("label");
    u.type = "radio", u.name = m.radio, u.value = a, gr(a, n.inputValue) && (u.checked = !0);
    const v = document.createElement("span");
    ye(v, i), v.className = m.label, d.appendChild(u), d.appendChild(v), o.appendChild(d);
  });
  const s = o.querySelectorAll("input");
  s.length && s[0].focus();
}
const tn = (e) => {
  const t = [];
  return e instanceof Map ? e.forEach((n, o) => {
    let s = n;
    typeof s == "object" && (s = tn(s)), t.push([o, s]);
  }) : Object.keys(e).forEach((n) => {
    let o = e[n];
    typeof o == "object" && (o = tn(o)), t.push([n, o]);
  }), t;
}, gr = (e, t) => !!t && t.toString() === e.toString(), au = (e) => {
  const t = q.innerParams.get(e);
  e.disableButtons(), t.input ? br(e, "confirm") : Eo(e, !0);
}, iu = (e) => {
  const t = q.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? br(e, "deny") : vo(e, !1);
}, lu = (e, t) => {
  e.disableButtons(), t(_t.cancel);
}, br = (e, t) => {
  const n = q.innerParams.get(e);
  if (!n.input) {
    ot(`The "input" parameter is needed to be set when using returnInputValueOn${io(t)}`);
    return;
  }
  const o = e.getInput(), s = Zc(e, n);
  n.inputValidator ? cu(e, s, t) : o && !o.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || o.validationMessage)) : t === "deny" ? vo(e, s) : Eo(e, s);
}, cu = (e, t, n) => {
  const o = q.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => It(o.inputValidator(t, o.validationMessage))).then((r) => {
    e.enableButtons(), e.enableInput(), r ? e.showValidationMessage(r) : n === "deny" ? vo(e, t) : Eo(e, t);
  });
}, vo = (e, t) => {
  const n = q.innerParams.get(e || void 0);
  n.showLoaderOnDeny && pt(st()), n.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => It(n.preDeny(t, n.validationMessage))).then((s) => {
    s === !1 ? (e.hideLoading(), Mt(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof s > "u" ? t : s
      }
    );
  }).catch((s) => _r(e || void 0, s))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, us = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, _r = (e, t) => {
  e.rejectPromise(t);
}, Eo = (e, t) => {
  const n = q.innerParams.get(e || void 0);
  n.showLoaderOnConfirm && pt(), n.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => It(n.preConfirm(t, n.validationMessage))).then((s) => {
    he(fn()) || s === !1 ? (e.hideLoading(), Mt(e)) : us(e, typeof s > "u" ? t : s);
  }).catch((s) => _r(e || void 0, s))) : us(e, t);
};
function nn() {
  const e = q.innerParams.get(this);
  if (!e)
    return;
  const t = q.domCache.get(this);
  fe(t.loader), pn() ? e.icon && ie(ht()) : uu(t), Ee([t.popup, t.actions], m.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), t.confirmButton.disabled = !1, t.denyButton.disabled = !1, t.cancelButton.disabled = !1;
}
const uu = (e) => {
  const t = e.popup.getElementsByClassName(e.loader.getAttribute("data-button-to-replace"));
  t.length ? ie(t[0], "inline-block") : Rl() && fe(e.actions);
};
function yr() {
  const e = q.innerParams.get(this), t = q.domCache.get(this);
  return t ? wn(t.popup, e.input) : null;
}
function vr(e, t, n) {
  const o = q.domCache.get(e);
  t.forEach((s) => {
    o[s].disabled = n;
  });
}
function Er(e, t) {
  const n = V();
  if (!(!n || !e))
    if (e.type === "radio") {
      const o = n.querySelectorAll(`[name="${m.radio}"]`);
      for (let s = 0; s < o.length; s++)
        o[s].disabled = t;
    } else
      e.disabled = t;
}
function kr() {
  vr(this, ["confirmButton", "denyButton", "cancelButton"], !1);
}
function Cr() {
  vr(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function Lr() {
  Er(this.getInput(), !1);
}
function Tr() {
  Er(this.getInput(), !0);
}
function Ar(e) {
  const t = q.domCache.get(this), n = q.innerParams.get(this);
  ye(t.validationMessage, e), t.validationMessage.className = m["validation-message"], n.customClass && n.customClass.validationMessage && j(t.validationMessage, n.customClass.validationMessage), ie(t.validationMessage);
  const o = this.getInput();
  o && (o.setAttribute("aria-invalid", "true"), o.setAttribute("aria-describedby", m["validation-message"]), Qs(o), j(o, m.inputerror));
}
function Nr() {
  const e = q.domCache.get(this);
  e.validationMessage && fe(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), Ee(t, m.inputerror));
}
const ut = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, du = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], fu = {
  allowEnterKey: void 0
}, mu = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], xr = (e) => Object.prototype.hasOwnProperty.call(ut, e), Or = (e) => du.indexOf(e) !== -1, Ir = (e) => fu[e], pu = (e) => {
  xr(e) || me(`Unknown parameter "${e}"`);
}, wu = (e) => {
  mu.includes(e) && me(`The parameter "${e}" is incompatible with toasts`);
}, hu = (e) => {
  const t = Ir(e);
  t && Xs(e, t);
}, Pr = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && me('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && me(`Invalid theme "${e.theme}"`);
  for (const t in e)
    pu(t), e.toast && wu(t), hu(t);
};
function Sr(e) {
  const t = pe(), n = V(), o = q.innerParams.get(this);
  if (!n || Ue(n, o.hideClass.popup)) {
    me("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const s = gu(e), r = Object.assign({}, o, s);
  Pr(r), t.dataset.swal2Theme = r.theme, cr(this, r), q.innerParams.set(this, r), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const gu = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    Or(n) ? t[n] = e[n] : me(`Invalid parameter to update: ${n}`);
  }), t;
};
function Dr() {
  const e = q.domCache.get(this), t = q.innerParams.get(this);
  if (!t) {
    $r(this);
    return;
  }
  e.popup && D.swalCloseEventFinishedCallback && (D.swalCloseEventFinishedCallback(), delete D.swalCloseEventFinishedCallback), typeof t.didDestroy == "function" && t.didDestroy(), D.eventEmitter.emit("didDestroy"), bu(this);
}
const bu = (e) => {
  $r(e), delete e.params, delete D.keydownHandler, delete D.keydownTarget, delete D.currentInstance;
}, $r = (e) => {
  e.isAwaitingPromise ? (Rn(q, e), e.isAwaitingPromise = !0) : (Rn(mt, e), Rn(q, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, Rn = (e, t) => {
  for (const n in e)
    e[n].delete(t);
};
var _u = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: Dr,
  close: We,
  closeModal: We,
  closePopup: We,
  closeToast: We,
  disableButtons: Cr,
  disableInput: Tr,
  disableLoading: nn,
  enableButtons: kr,
  enableInput: Lr,
  getInput: yr,
  handleAwaitingPromise: Mt,
  hideLoading: nn,
  rejectPromise: hr,
  resetValidationMessage: Nr,
  showValidationMessage: Ar,
  update: Sr
});
const yu = (e, t, n) => {
  e.toast ? vu(e, t, n) : (ku(t), Cu(t), Lu(e, t, n));
}, vu = (e, t, n) => {
  t.popup.onclick = () => {
    e && (Eu(e) || e.timer || e.input) || n(_t.close);
  };
}, Eu = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let on = !1;
const ku = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (on = !0);
    };
  };
}, Cu = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(n) {
      e.popup.onmouseup = () => {
      }, (n.target === e.popup || n.target instanceof HTMLElement && e.popup.contains(n.target)) && (on = !0);
    };
  };
}, Lu = (e, t, n) => {
  t.container.onclick = (o) => {
    if (on) {
      on = !1;
      return;
    }
    o.target === t.container && dn(e.allowOutsideClick) && n(_t.backdrop);
  };
}, Tu = (e) => typeof e == "object" && e.jquery, ds = (e) => e instanceof Element || Tu(e), Au = (e) => {
  const t = {};
  return typeof e[0] == "object" && !ds(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((n, o) => {
    const s = e[o];
    typeof s == "string" || ds(s) ? t[n] = s : s !== void 0 && ot(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof s}`);
  }), t;
};
function Nu(...e) {
  return new this(...e);
}
function xu(e) {
  class t extends this {
    _main(o, s) {
      return super._main(o, Object.assign({}, e, s));
    }
  }
  return t;
}
const Ou = () => D.timeout && D.timeout.getTimerLeft(), Mr = () => {
  if (D.timeout)
    return Ul(), D.timeout.stop();
}, Rr = () => {
  if (D.timeout) {
    const e = D.timeout.start();
    return go(e), e;
  }
}, Iu = () => {
  const e = D.timeout;
  return e && (e.running ? Mr() : Rr());
}, Pu = (e) => {
  if (D.timeout) {
    const t = D.timeout.increase(e);
    return go(t, !0), t;
  }
}, Su = () => !!(D.timeout && D.timeout.isRunning());
let fs = !1;
const Jn = {};
function Du(e = "data-swal-template") {
  Jn[e] = this, fs || (document.body.addEventListener("click", $u), fs = !0);
}
const $u = (e) => {
  for (let t = e.target; t && t !== document; t = t.parentNode)
    for (const n in Jn) {
      const o = t.getAttribute(n);
      if (o) {
        Jn[n].fire({
          template: o
        });
        return;
      }
    }
};
class Mu {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, n) {
    const o = this._getHandlersByEventName(t);
    o.includes(n) || o.push(n);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, n) {
    const o = (...s) => {
      this.removeListener(t, o), n.apply(this, s);
    };
    this.on(t, o);
  }
  /**
   * @param {string} eventName
   * @param {Array} args
   */
  emit(t, ...n) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (o) => {
        try {
          o.apply(this, n);
        } catch (s) {
          console.error(s);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, n) {
    const o = this._getHandlersByEventName(t), s = o.indexOf(n);
    s > -1 && o.splice(s, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
D.eventEmitter = new Mu();
const Ru = (e, t) => {
  D.eventEmitter.on(e, t);
}, Fu = (e, t) => {
  D.eventEmitter.once(e, t);
}, Uu = (e, t) => {
  if (!e) {
    D.eventEmitter.reset();
    return;
  }
  t ? D.eventEmitter.removeListener(e, t) : D.eventEmitter.removeAllListeners(e);
};
var Bu = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: Au,
  bindClickHandler: Du,
  clickCancel: Ac,
  clickConfirm: ur,
  clickDeny: Tc,
  enableLoading: pt,
  fire: Nu,
  getActions: St,
  getCancelButton: gt,
  getCloseButton: mo,
  getConfirmButton: Pe,
  getContainer: pe,
  getDenyButton: st,
  getFocusableElements: po,
  getFooter: Zs,
  getHtmlContainer: uo,
  getIcon: ht,
  getIconContent: Pl,
  getImage: Js,
  getInputLabel: Sl,
  getLoader: bt,
  getPopup: V,
  getProgressSteps: fo,
  getTimerLeft: Ou,
  getTimerProgressBar: mn,
  getTitle: zs,
  getValidationMessage: fn,
  increaseTimer: Pu,
  isDeprecatedParameter: Ir,
  isLoading: $l,
  isTimerRunning: Su,
  isUpdatableParameter: Or,
  isValidParameter: xr,
  isVisible: Lc,
  mixin: xu,
  off: Uu,
  on: Ru,
  once: Fu,
  resumeTimer: Rr,
  showLoading: pt,
  stopTimer: Mr,
  toggleTimer: Iu
});
class Vu {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, n) {
    this.callback = t, this.remaining = n, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const n = this.running;
    return n && this.stop(), this.remaining += t, n && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const Fr = ["swal-title", "swal-html", "swal-footer"], Hu = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const n = t.content;
  return zu(n), Object.assign(ju(n), Wu(n), Ku(n), Yu(n), Gu(n), qu(n), Xu(n, Fr));
}, ju = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((o) => {
    nt(o, ["name", "value"]);
    const s = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), r = o.getAttribute("value");
    !s || !r || (typeof ut[s] == "boolean" ? t[s] = r !== "false" : typeof ut[s] == "object" ? t[s] = JSON.parse(r) : t[s] = r);
  }), t;
}, Wu = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((o) => {
    const s = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), r = o.getAttribute("value");
    !s || !r || (t[s] = new Function(`return ${r}`)());
  }), t;
}, Ku = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((o) => {
    nt(o, ["type", "color", "aria-label"]);
    const s = o.getAttribute("type");
    !s || !["confirm", "cancel", "deny"].includes(s) || (t[`${s}ButtonText`] = o.innerHTML, t[`show${io(s)}Button`] = !0, o.hasAttribute("color") && (t[`${s}ButtonColor`] = o.getAttribute("color")), o.hasAttribute("aria-label") && (t[`${s}ButtonAriaLabel`] = o.getAttribute("aria-label")));
  }), t;
}, Yu = (e) => {
  const t = {}, n = e.querySelector("swal-image");
  return n && (nt(n, ["src", "width", "height", "alt"]), n.hasAttribute("src") && (t.imageUrl = n.getAttribute("src") || void 0), n.hasAttribute("width") && (t.imageWidth = n.getAttribute("width") || void 0), n.hasAttribute("height") && (t.imageHeight = n.getAttribute("height") || void 0), n.hasAttribute("alt") && (t.imageAlt = n.getAttribute("alt") || void 0)), t;
}, Gu = (e) => {
  const t = {}, n = e.querySelector("swal-icon");
  return n && (nt(n, ["type", "color"]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
}, qu = (e) => {
  const t = {}, n = e.querySelector("swal-input");
  n && (nt(n, ["type", "label", "placeholder", "value"]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
  const o = Array.from(e.querySelectorAll("swal-input-option"));
  return o.length && (t.inputOptions = {}, o.forEach((s) => {
    nt(s, ["value"]);
    const r = s.getAttribute("value");
    if (!r)
      return;
    const a = s.innerHTML;
    t.inputOptions[r] = a;
  })), t;
}, Xu = (e, t) => {
  const n = {};
  for (const o in t) {
    const s = t[o], r = e.querySelector(s);
    r && (nt(r, []), n[s.replace(/^swal-/, "")] = r.innerHTML.trim());
  }
  return n;
}, zu = (e) => {
  const t = Fr.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((n) => {
    const o = n.tagName.toLowerCase();
    t.includes(o) || me(`Unrecognized element <${o}>`);
  });
}, nt = (e, t) => {
  Array.from(e.attributes).forEach((n) => {
    t.indexOf(n.name) === -1 && me([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, Ur = 10, Ju = (e) => {
  const t = pe(), n = V();
  typeof e.willOpen == "function" && e.willOpen(n), D.eventEmitter.emit("willOpen", n);
  const s = window.getComputedStyle(document.body).overflowY;
  ed(t, n, e), setTimeout(() => {
    Zu(t, n);
  }, Ur), wo() && (Qu(t, e.scrollbarPadding, s), $c()), !pn() && !D.previousActiveElement && (D.previousActiveElement = document.activeElement), typeof e.didOpen == "function" && setTimeout(() => e.didOpen(n)), D.eventEmitter.emit("didOpen", n);
}, sn = (e) => {
  const t = V();
  if (e.target !== t)
    return;
  const n = pe();
  t.removeEventListener("animationend", sn), t.removeEventListener("transitionend", sn), n.style.overflowY = "auto", Ee(n, m["no-transition"]);
}, Zu = (e, t) => {
  tr(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", sn), t.addEventListener("transitionend", sn)) : e.style.overflowY = "auto";
}, Qu = (e, t, n) => {
  Mc(), t && n !== "hidden" && jc(n), setTimeout(() => {
    e.scrollTop = 0;
  });
}, ed = (e, t, n) => {
  j(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), ie(t, "grid"), setTimeout(() => {
    j(t, n.showClass.popup), t.style.removeProperty("opacity");
  }, Ur)) : ie(t, "grid"), j([document.documentElement, document.body], m.shown), n.heightAuto && n.backdrop && !n.toast && j([document.documentElement, document.body], m["height-auto"]);
};
var ms = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function td(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = ms.email), e.input === "url" && (e.inputValidator = ms.url));
}
function nd(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (me('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function od(e) {
  td(e), e.showLoaderOnConfirm && !e.preConfirm && me(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), nd(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), Gl(e);
}
let xe;
var jt = /* @__PURE__ */ new WeakMap();
class oe {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (Cl(this, jt, void 0), typeof window > "u")
      return;
    xe = this;
    const n = Object.freeze(this.constructor.argsToParams(t));
    this.params = n, this.isAwaitingPromise = !1, Ll(jt, this, this._main(xe.params));
  }
  _main(t, n = {}) {
    if (Pr(Object.assign({}, n, t)), D.currentInstance) {
      const r = mt.swalPromiseResolve.get(D.currentInstance), {
        isAwaitingPromise: a
      } = D.currentInstance;
      D.currentInstance._destroy(), a || r({
        isDismissed: !0
      }), wo() && mr();
    }
    D.currentInstance = xe;
    const o = rd(t, n);
    od(o), Object.freeze(o), D.timeout && (D.timeout.stop(), delete D.timeout), clearTimeout(D.restoreFocusTimeout);
    const s = ad(xe);
    return cr(xe, o), q.innerParams.set(xe, o), sd(xe, s, o);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  then(t) {
    return os(jt, this).then(t);
  }
  finally(t) {
    return os(jt, this).finally(t);
  }
}
const sd = (e, t, n) => new Promise((o, s) => {
  const r = (a) => {
    e.close({
      isDismissed: !0,
      dismiss: a,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  mt.swalPromiseResolve.set(e, o), mt.swalPromiseReject.set(e, s), t.confirmButton.onclick = () => {
    au(e);
  }, t.denyButton.onclick = () => {
    iu(e);
  }, t.cancelButton.onclick = () => {
    lu(e, r);
  }, t.closeButton.onclick = () => {
    r(_t.close);
  }, yu(n, t, r), Nc(D, n, r), Jc(e, n), Ju(n), id(D, n, r), ld(t, n), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), rd = (e, t) => {
  const n = Hu(e), o = Object.assign({}, ut, t, n, e);
  return o.showClass = Object.assign({}, ut.showClass, o.showClass), o.hideClass = Object.assign({}, ut.hideClass, o.hideClass), o.animation === !1 && (o.showClass = {
    backdrop: "swal2-noanimation"
  }, o.hideClass = {}), o;
}, ad = (e) => {
  const t = {
    popup: V(),
    container: pe(),
    actions: St(),
    confirmButton: Pe(),
    denyButton: st(),
    cancelButton: gt(),
    loader: bt(),
    closeButton: mo(),
    validationMessage: fn(),
    progressSteps: fo()
  };
  return q.domCache.set(e, t), t;
}, id = (e, t, n) => {
  const o = mn();
  fe(o), t.timer && (e.timeout = new Vu(() => {
    n("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && (ie(o), be(o, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && go(t.timer);
  })));
}, ld = (e, t) => {
  if (!t.toast) {
    if (!dn(t.allowEnterKey)) {
      Xs("allowEnterKey"), dd();
      return;
    }
    cd(e) || ud(e, t) || zn(-1, 1);
  }
}, cd = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const n of t)
    if (n instanceof HTMLElement && he(n))
      return n.focus(), !0;
  return !1;
}, ud = (e, t) => t.focusDeny && he(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && he(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && he(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1, dd = () => {
  document.activeElement instanceof HTMLElement && typeof document.activeElement.blur == "function" && document.activeElement.blur();
};
oe.prototype.disableButtons = Cr;
oe.prototype.enableButtons = kr;
oe.prototype.getInput = yr;
oe.prototype.disableInput = Tr;
oe.prototype.enableInput = Lr;
oe.prototype.hideLoading = nn;
oe.prototype.disableLoading = nn;
oe.prototype.showValidationMessage = Ar;
oe.prototype.resetValidationMessage = Nr;
oe.prototype.close = We;
oe.prototype.closePopup = We;
oe.prototype.closeModal = We;
oe.prototype.closeToast = We;
oe.prototype.rejectPromise = hr;
oe.prototype.update = Sr;
oe.prototype._destroy = Dr;
Object.assign(oe, Bu);
Object.keys(_u).forEach((e) => {
  oe[e] = function(...t) {
    return xe && xe[e] ? xe[e](...t) : null;
  };
});
oe.DismissReason = _t;
oe.version = "11.26.10";
const rn = oe;
rn.default = rn;
typeof document < "u" && function(e, t) {
  var n = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
  else try {
    n.innerHTML = t;
  } catch {
    n.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-icon-animations: true;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem;container-name:swal2-popup}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:all}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}@container swal2-popup style(--swal2-icon-animations:true){.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
const fd = { class: "merchant-lib-container" }, md = { class: "lib-header" }, pd = { class: "header-content" }, wd = { class: "lib-title" }, hd = { class: "admin-chip-container" }, gd = { class: "lib-description" }, bd = {
  key: 0,
  class: "status-box error"
}, _d = { class: "info-list" }, yd = { class: "item-row" }, vd = { class: "username" }, Ed = { class: "row-actions" }, kd = ["title"], Cd = ["checked", "onChange"], Ld = { class: "role-dots" }, Td = ["title"], Ad = { class: "lib-footer" }, Nd = /* @__PURE__ */ Te({
  __name: "MerchantUserPage",
  props: {
    userApi: {}
  },
  setup(e) {
    const { t } = Se(), n = e, { userList: o, adminNames: s, loading: r, error: a, fetchUsers: i, toggleUserStatus: u } = El(n.userApi);
    ws(async () => {
      await i();
    });
    const d = async (v) => {
      try {
        await u(v), await rn.fire({
          icon: "success",
          title: t("personnel.updateSuccess"),
          timer: 1e3,
          showConfirmButton: !1
        });
      } catch {
      }
    };
    return (v, C) => (K(), G("section", fd, [
      f("header", md, [
        f("div", pd, [
          f("h1", wd, N(_(t)("personnel.title")), 1),
          f("div", hd, [
            (K(!0), G(Je, null, Tt(_(s), (h) => (K(), G("span", {
              key: h,
              class: "admin-chip"
            }, N(_(t)("personnel.adminLabel")) + ": " + N(h), 1))), 128))
          ])
        ]),
        f("p", gd, N(_(t)("personnel.subtitle")), 1)
      ]),
      _(a) ? (K(), G("div", bd, N(_(a)), 1)) : Fe("", !0),
      f("div", _d, [
        _(r) ? (K(), G(Je, { key: 0 }, Tt(3, (h) => f("div", {
          key: h,
          class: "list-item-skeleton"
        }, [...C[1] || (C[1] = [
          f("div", { class: "skeleton-line wide" }, null, -1),
          f("div", { class: "skeleton-line medium" }, null, -1)
        ])])), 64)) : (K(!0), G(Je, { key: 1 }, Tt(_(o), (h) => {
          var P;
          return K(), G("div", {
            key: h.id,
            class: "list-item"
          }, [
            f("div", yd, [
              f("span", vd, N(h.username), 1),
              f("div", Ed, [
                h.roles.some(($) => $.Name === "ROLE_MERCHANT") ? Fe("", !0) : (K(), G("label", {
                  key: 0,
                  class: "switch",
                  title: _(t)("personnel.toggleStatus")
                }, [
                  f("input", {
                    type: "checkbox",
                    checked: (P = h.userInfo) == null ? void 0 : P.enabled,
                    onChange: ($) => d(h)
                  }, null, 40, Cd),
                  C[2] || (C[2] = f("span", { class: "slider round" }, null, -1))
                ], 8, kd)),
                f("div", Ld, [
                  (K(!0), G(Je, null, Tt(h.roles, ($) => (K(), G("span", {
                    key: $.id,
                    class: Kr(["role-dot", { "is-merchant": $.Name === "ROLE_MERCHANT" }]),
                    title: $.Name === "ROLE_MERCHANT" ? _(t)("personnel.roleAdmin") : _(t)("personnel.roleStaff")
                  }, null, 10, Td))), 128))
                ])
              ])
            ])
          ]);
        }), 128))
      ]),
      f("footer", Ad, [
        f("button", {
          onClick: C[0] || (C[0] = //@ts-ignore
          (...h) => _(i) && _(i)(...h)),
          class: "btn-refresh"
        }, N(_(t)("personnel.refreshBtn")), 1)
      ])
    ]));
  }
}), ko = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, s] of t)
    n[o] = s;
  return n;
}, Qf = /* @__PURE__ */ ko(Nd, [["__scopeId", "data-v-99b6167b"]]);
function xd(e) {
  const t = de(!1), n = de(null), o = de(!1);
  return {
    isDeleting: t,
    securityError: n,
    deletionSuccess: o,
    requestDeletion: async () => {
      var r, a;
      t.value = !0, n.value = null;
      try {
        const i = await e.requestAccountDeletion();
        return o.value = !0, i;
      } catch (i) {
        throw n.value = ((a = (r = i.response) == null ? void 0 : r.data) == null ? void 0 : a.message) || "請求刪除失敗，請稍後再試", i;
      } finally {
        t.value = !1;
      }
    }
  };
}
const Od = { class: "p-6 bg-white rounded-2xl shadow-xl border border-gray-100" }, Id = { class: "text-xl font-black text-red-600 mb-4" }, Pd = { key: 0 }, Sd = { class: "text-gray-700 mb-6 leading-relaxed space-y-2" }, Dd = { class: "list-disc list-inside text-sm text-gray-500" }, $d = {
  key: 0,
  class: "mb-4 p-4 bg-red-50 text-red-700 rounded-lg border border-red-100 text-sm"
}, Md = { class: "flex gap-3" }, Rd = ["disabled"], Fd = ["disabled"], Ud = {
  key: 1,
  class: "text-center py-4"
}, Bd = { class: "text-gray-800 font-bold mb-6" }, Vd = /* @__PURE__ */ Te({
  __name: "AccountDeletionModal",
  props: {
    userSecurityApi: {}
  },
  emits: ["cancel", "logout"],
  setup(e, { emit: t }) {
    const { t: n } = Se(), o = e, { isDeleting: s, securityError: r, deletionSuccess: a, requestDeletion: i } = xd(o.userSecurityApi), u = async () => {
      try {
        await i();
      } catch {
      }
    };
    return (d, v) => (K(), G("div", Od, [
      f("h2", Id, N(_(n)("security.deleteAccountTitle")), 1),
      _(a) ? (K(), G("div", Ud, [
        v[2] || (v[2] = f("div", { class: "text-green-500 text-5xl mb-4" }, "✅", -1)),
        f("p", Bd, N(_(n)("security.deleteRequestSuccess")), 1),
        f("button", {
          onClick: v[1] || (v[1] = (C) => d.$emit("logout")),
          class: "w-full py-4 bg-gray-800 text-white rounded-xl font-bold active:scale-[0.98] transition-transform"
        }, N(_(n)("security.logoutAndConfirm")), 1)
      ])) : (K(), G("div", Pd, [
        f("div", Sd, [
          f("p", null, N(_(n)("security.deleteAccountConfirm")), 1),
          f("ul", Dd, [
            f("li", null, N(_(n)("security.deleteEffectSuspend")), 1),
            f("li", null, N(_(n)("security.deleteEffectWipeout")), 1),
            f("li", null, N(_(n)("security.deleteEffectIrreversible")), 1)
          ])
        ]),
        _(r) ? (K(), G("div", $d, " ❌ " + N(_(r)), 1)) : Fe("", !0),
        f("div", Md, [
          f("button", {
            onClick: v[0] || (v[0] = (C) => d.$emit("cancel")),
            disabled: _(s),
            class: "flex-1 py-3 border border-gray-300 rounded-xl font-bold text-gray-600 hover:bg-gray-50 transition-colors"
          }, N(_(n)("common.cancel")), 9, Rd),
          f("button", {
            onClick: u,
            disabled: _(s),
            class: "flex-1 py-3 bg-red-600 text-white rounded-xl font-bold shadow-lg shadow-red-100 active:scale-[0.98] transition-all disabled:bg-gray-100 disabled:text-gray-400"
          }, N(_(s) ? _(n)("common.processing") : _(n)("security.confirmDeleteBtn")), 9, Fd)
        ])
      ]))
    ]));
  }
}), Hd = { class: "user-security-panel" }, jd = ["aria-label"], Wd = { class: "flex items-center gap-3" }, Kd = { class: "text-left" }, Yd = { class: "font-bold text-base leading-tight" }, Gd = { class: "text-xs text-red-400 mt-1" }, qd = { class: "w-full max-w-[min(100%,384px)] animate-in fade-in zoom-in duration-200" }, em = /* @__PURE__ */ Te({
  __name: "UserSecurityPanel",
  props: {
    userSecurityApi: {}
  },
  emits: ["onLogoutRequired"],
  setup(e, { emit: t }) {
    const { t: n } = Se(), o = t, s = de(!1), r = () => {
      s.value = !1, o("onLogoutRequired");
    };
    return (a, i) => (K(), G("div", Hd, [
      f("button", {
        onClick: i[0] || (i[0] = (u) => s.value = !0),
        class: "flex items-center justify-between w-full p-4 bg-red-50 text-red-600 rounded-2xl hover:bg-red-100 transition-colors group",
        "aria-label": _(n)("security.deleteAccountTitle")
      }, [
        f("div", Wd, [
          i[3] || (i[3] = f("span", { class: "text-xl group-hover:scale-110 transition-transform" }, "🗑️", -1)),
          f("div", Kd, [
            f("p", Yd, N(_(n)("security.deleteAccountTitle")), 1),
            f("p", Gd, N(_(n)("security.deleteAccountSummary")), 1)
          ])
        ]),
        i[4] || (i[4] = f("span", { class: "text-gray-400 group-hover:translate-x-1 transition-transform" }, "❯", -1))
      ], 8, jd),
      (K(), Yr(Gr, { to: "body" }, [
        s.value ? (K(), G("div", {
          key: 0,
          class: "fixed inset-0 z-100 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm",
          onClick: i[2] || (i[2] = gs((u) => s.value = !1, ["self"]))
        }, [
          f("div", qd, [
            dt(Vd, {
              userSecurityApi: e.userSecurityApi,
              onCancel: i[1] || (i[1] = (u) => s.value = !1),
              onLogout: r
            }, null, 8, ["userSecurityApi"])
          ])
        ])) : Fe("", !0)
      ]))
    ]));
  }
}), Xd = { class: "w-full px-4 py-6 sm:py-10 bg-gray-50" }, zd = { class: "max-w-[min(100%,448px)] mx-auto p-6 bg-white rounded-2xl shadow-xl border border-gray-100" }, Jd = { class: "mb-8" }, Zd = { class: "text-2xl font-black text-gray-700" }, Qd = { class: "text-gray-500 mt-2 text-sm leading-relaxed" }, ef = { class: "space-y-6" }, tf = { class: "block text-sm font-bold text-blue-700 mb-2" }, nf = { class: "p-4 rounded-xl border border-blue-50 bg-blue-50/30 text-gray-700 text-sm leading-relaxed" }, of = { class: "block text-sm font-bold text-gray-700 mb-2" }, sf = { class: "p-4 rounded-xl border border-gray-100 bg-gray-50 text-gray-700 text-sm" }, rf = { class: "mb-2" }, af = { class: "mt-3 text-xs text-gray-400 italic" }, lf = { class: "p-4 bg-red-50 text-red-700 rounded-lg border border-red-100 text-xs leading-relaxed" }, cf = { class: "font-black" }, uf = /* @__PURE__ */ Te({
  __name: "DataDeletionPage",
  setup(e) {
    const { t } = Se();
    return (n, o) => {
      const s = Zn("router-link");
      return K(), G("div", Xd, [
        f("div", zd, [
          f("header", Jd, [
            f("h2", Zd, N(_(t)("deletionPage.title")), 1),
            f("p", Qd, N(_(t)("deletionPage.description")), 1)
          ]),
          f("div", ef, [
            f("section", null, [
              f("label", tf, N(_(t)("deletionPage.method1Title")), 1),
              f("div", nf, N(_(t)("deletionPage.method1Desc")), 1)
            ]),
            f("section", null, [
              f("label", of, N(_(t)("deletionPage.method2Title")), 1),
              f("div", sf, [
                f("p", rf, N(_(t)("deletionPage.method2Desc")), 1),
                o[0] || (o[0] = f("a", {
                  href: "mailto:bloomingrice12@gmail.com",
                  class: "text-blue-700 font-bold underline decoration-2 underline-offset-4"
                }, " bloomingrice12@gmail.com ", -1)),
                f("p", af, N(_(t)("deletionPage.emailSubject")), 1)
              ])
            ]),
            f("div", lf, [
              f("span", cf, "⚠️ " + N(_(t)("common.important") || "Important") + ":", 1),
              Me(" " + N(_(t)("deletionPage.footerNote")), 1)
            ]),
            dt(s, {
              to: "/",
              class: "block w-full py-4 rounded-xl font-bold text-center transition-all bg-gray-800 text-white active:scale-[0.98] shadow-lg shadow-gray-200"
            }, {
              default: Kt(() => [
                Me(N(_(t)("common.backToHome") || "Back to Home"), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]);
    };
  }
}), tm = /* @__PURE__ */ ko(uf, [["__scopeId", "data-v-8a6edab9"]]), df = { class: "w-full px-4 py-6 sm:py-10 bg-gray-50" }, ff = { class: "max-w-[min(100%,480px)] mx-auto p-8 bg-white rounded-2xl shadow-xl border border-gray-100" }, mf = { class: "mb-8 border-b border-gray-50 pb-6 text-center" }, pf = { class: "text-2xl font-black text-gray-800" }, wf = { class: "mt-4 text-sm text-gray-600 leading-relaxed px-2" }, hf = { class: "text-xs text-gray-400 mt-2 italic" }, gf = { class: "space-y-8 text-sm leading-relaxed text-gray-600" }, bf = { class: "font-bold text-gray-800 text-base mb-2" }, _f = { class: "bg-gray-50 p-4 rounded-xl border border-gray-100" }, yf = { class: "pt-6" }, vf = { class: "mt-10 text-center" }, nm = /* @__PURE__ */ Te({
  __name: "PrivacyPolicyPage",
  setup(e) {
    const { t } = Se();
    return (n, o) => {
      const s = Zn("router-link");
      return K(), G("div", df, [
        f("div", ff, [
          f("header", mf, [
            f("h1", pf, N(_(t)("privacy.title")), 1),
            f("p", wf, N(_(t)("privacy.intro")), 1),
            f("p", hf, N(_(t)("privacy.updateDate")), 1)
          ]),
          f("div", gf, [
            (K(), G(Je, null, Tt([1, 2, 3], (r) => f("section", { key: r }, [
              f("h2", bf, N(_(t)(`privacy.section${r}Title`)), 1),
              f("p", _f, N(_(t)(`privacy.section${r}Content`)), 1)
            ])), 64)),
            f("div", yf, [
              dt(s, {
                to: "/account-delete",
                class: "block p-4 rounded-xl border border-blue-100 bg-blue-50 text-blue-700 text-center font-bold hover:bg-blue-100 transition-colors"
              }, {
                default: Kt(() => [
                  Me(N(_(t)("deletionPage.title")) + " → ", 1)
                ]),
                _: 1
              })
            ])
          ]),
          f("footer", vf, [
            dt(s, {
              to: "/",
              class: "text-gray-400 text-xs hover:text-gray-600 transition-colors"
            }, {
              default: Kt(() => [
                Me(N(_(t)("common.backToHome")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]);
    };
  }
}), Ef = { class: "w-full px-4 py-6 sm:py-10 bg-gray-50 text-left" }, kf = { class: "max-w-[min(100%,600px)] mx-auto p-6 sm:p-10 bg-white rounded-2xl shadow-xl border border-gray-100" }, Cf = { class: "mb-8 border-b border-gray-100 pb-6 text-center" }, Lf = { class: "text-2xl font-black text-gray-800" }, Tf = { class: "text-xs text-gray-400 mt-2 italic" }, Af = { class: "space-y-8 text-sm leading-relaxed text-gray-600" }, Nf = { class: "font-bold text-gray-800 text-base mb-2 flex items-center" }, xf = { class: "bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2" }, Of = { class: "font-bold text-blue-700" }, If = { class: "font-bold text-gray-800 text-base mb-2 flex items-center" }, Pf = { class: "bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2" }, Sf = { class: "font-medium text-red-600" }, Df = { class: "font-bold text-gray-800 text-base mb-2 flex items-center" }, $f = { class: "bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2" }, Mf = { class: "font-bold underline text-gray-800" }, Rf = { class: "font-bold text-gray-800 text-base mb-2 flex items-center" }, Ff = { class: "bg-gray-50 p-4 rounded-xl border border-gray-100" }, Uf = { class: "mt-10 text-center" }, om = /* @__PURE__ */ Te({
  __name: "TermsOfService",
  setup(e) {
    const { t } = Se();
    return (n, o) => {
      const s = Zn("router-link");
      return K(), G("div", Ef, [
        f("div", kf, [
          f("header", Cf, [
            f("h1", Lf, N(_(t)("terms.title")), 1),
            f("p", Tf, N(_(t)("terms.updateDate")) + "：2026-01-15", 1)
          ]),
          f("div", Af, [
            f("section", null, [
              f("h2", Nf, [
                o[0] || (o[0] = f("span", { class: "bg-blue-700 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs mr-2 shrink-0" }, "1", -1)),
                Me(" " + N(_(t)("terms.section1.title")), 1)
              ]),
              f("div", xf, [
                f("p", null, N(_(t)("terms.section1.p1")), 1),
                f("p", Of, N(_(t)("terms.section1.p2")), 1),
                f("p", null, N(_(t)("terms.section1.p3")), 1)
              ])
            ]),
            f("section", null, [
              f("h2", If, [
                o[1] || (o[1] = f("span", { class: "bg-blue-700 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs mr-2 shrink-0" }, "2", -1)),
                Me(" " + N(_(t)("terms.section2.title")), 1)
              ]),
              f("div", Pf, [
                f("p", null, N(_(t)("terms.section2.p1")), 1),
                f("p", Sf, N(_(t)("terms.section2.p2")), 1),
                f("p", null, N(_(t)("terms.section2.p3")), 1),
                f("p", null, N(_(t)("terms.section2.p4")), 1)
              ])
            ]),
            f("section", null, [
              f("h2", Df, [
                o[2] || (o[2] = f("span", { class: "bg-blue-700 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs mr-2 shrink-0" }, "3", -1)),
                Me(" " + N(_(t)("terms.section3.title")), 1)
              ]),
              f("div", $f, [
                f("p", null, N(_(t)("terms.section3.p1")), 1),
                f("p", Mf, N(_(t)("terms.section3.p2")), 1)
              ])
            ]),
            f("section", null, [
              f("h2", Rf, [
                o[3] || (o[3] = f("span", { class: "bg-blue-700 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs mr-2 shrink-0" }, "4", -1)),
                Me(" " + N(_(t)("terms.section4.title")), 1)
              ]),
              f("p", Ff, N(_(t)("terms.section4.p1")), 1)
            ])
          ]),
          f("footer", Uf, [
            dt(s, {
              to: "/",
              class: "text-gray-400 text-xs hover:text-gray-600 transition-colors"
            }, {
              default: Kt(() => [
                Me(N(_(t)("common.backToHome")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]);
    };
  }
});
function Bf(e) {
  const t = de(!1), n = de(null), o = de(!1);
  return {
    loading: t,
    error: n,
    success: o,
    updateKeys: async (r) => {
      t.value = !0, n.value = null, o.value = !1;
      try {
        const a = await e.saveMerchantKeys(r);
        o.value = a.success;
      } catch (a) {
        throw n.value = (a == null ? void 0 : a.message) || "更新金鑰失敗，請稍後再試", o.value = !1, a;
      } finally {
        t.value = !1;
      }
    }
  };
}
const Vf = { class: "merchant-keys-container" }, Hf = { class: "form-group" }, jf = { class: "form-group" }, Wf = { class: "form-group" }, Kf = { class: "form-group" }, Yf = { class: "form-group" }, Gf = {
  key: 0,
  class: "message error-message"
}, qf = {
  key: 1,
  class: "message success-message"
}, Xf = ["disabled"], zf = /* @__PURE__ */ Te({
  __name: "MerchantKeysPage",
  props: {
    merchantKeysApi: {}
  },
  setup(e) {
    const t = e, n = hs({
      ecpayMerchantID: "",
      payHashKey: "",
      payHashIV: "",
      invoiceHashKey: "",
      invoiceHashIV: ""
    }), { loading: o, error: s, success: r, updateKeys: a } = Bf(t.merchantKeysApi), i = async () => {
      try {
        await a({ ...n });
      } catch (u) {
        console.error("Submit failed:", u);
      }
    };
    return (u, d) => (K(), G("div", Vf, [
      d[12] || (d[12] = f("h2", null, "配置/更新特店金鑰 (綠界 Helper)", -1)),
      d[13] || (d[13] = f("hr", null, null, -1)),
      f("form", {
        onSubmit: gs(i, ["prevent"]),
        class: "keys-form"
      }, [
        f("div", Hf, [
          d[5] || (d[5] = f("label", { for: "ecpayMerchantID" }, "綠界特店編號 (MerchantID)", -1)),
          He(f("input", {
            id: "ecpayMerchantID",
            "onUpdate:modelValue": d[0] || (d[0] = (v) => n.ecpayMerchantID = v),
            type: "text",
            placeholder: "例如: 12345678",
            required: ""
          }, null, 512), [
            [it, n.ecpayMerchantID]
          ])
        ]),
        f("fieldset", null, [
          d[8] || (d[8] = f("legend", null, "付款金鑰 (Pay Keys)", -1)),
          f("div", jf, [
            d[6] || (d[6] = f("label", { for: "payHashKey" }, "HashKey", -1)),
            He(f("input", {
              id: "payHashKey",
              "onUpdate:modelValue": d[1] || (d[1] = (v) => n.payHashKey = v),
              type: "text",
              required: ""
            }, null, 512), [
              [it, n.payHashKey]
            ])
          ]),
          f("div", Wf, [
            d[7] || (d[7] = f("label", { for: "payHashIV" }, "HashIV", -1)),
            He(f("input", {
              id: "payHashIV",
              "onUpdate:modelValue": d[2] || (d[2] = (v) => n.payHashIV = v),
              type: "text",
              required: ""
            }, null, 512), [
              [it, n.payHashIV]
            ])
          ])
        ]),
        f("fieldset", null, [
          d[11] || (d[11] = f("legend", null, "電子發票金鑰 (Invoice Keys)", -1)),
          f("div", Kf, [
            d[9] || (d[9] = f("label", { for: "invoiceHashKey" }, "HashKey", -1)),
            He(f("input", {
              id: "invoiceHashKey",
              "onUpdate:modelValue": d[3] || (d[3] = (v) => n.invoiceHashKey = v),
              type: "text",
              required: ""
            }, null, 512), [
              [it, n.invoiceHashKey]
            ])
          ]),
          f("div", Yf, [
            d[10] || (d[10] = f("label", { for: "invoiceHashIV" }, "HashIV", -1)),
            He(f("input", {
              id: "invoiceHashIV",
              "onUpdate:modelValue": d[4] || (d[4] = (v) => n.invoiceHashIV = v),
              type: "text",
              required: ""
            }, null, 512), [
              [it, n.invoiceHashIV]
            ])
          ])
        ]),
        _(s) ? (K(), G("div", Gf, N(_(s)), 1)) : Fe("", !0),
        _(r) ? (K(), G("div", qf, "金鑰配置更新成功！")) : Fe("", !0),
        f("button", {
          type: "submit",
          disabled: _(o)
        }, N(_(o) ? "正在儲存..." : "儲存配置 (Upsert)"), 9, Xf)
      ], 32)
    ]));
  }
}), sm = /* @__PURE__ */ ko(zf, [["__scopeId", "data-v-18e0cb3c"]]);
export {
  Zf as ChangePasswordPage,
  tm as DataDeletionPage,
  sm as MerchantKeysPage,
  Qf as MerchantUserPage,
  nm as PrivacyPolicyPage,
  om as TermsOfService,
  em as UserSecurityPanel
};
